/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  AiModelName,
  AiModelStatusCount,
  AnswerOption,
  Assessment,
  AssessmentCount,
  AssessmentDetail,
  AssessmentResults,
  AuxiliaryRiskMetricResult,
  Comment,
  ConciergeResultsAccepted,
  ConciergeResultsUpload,
  CredentialRead,
  CredentialWrite,
  CustomFieldDefinition,
  CustomFieldValueCreate,
  CustomFieldValueRead,
  CustomFieldValueUpdate,
  Department,
  EnhancedGovernance,
  EvidenceArtefactSerialiser,
  EvidenceSerialiser,
  FeatureFlagPayload,
  Finding,
  FindingWrite,
  GovernanceAnswer,
  GovernanceCustomQuestionnaire,
  Infobox,
  InsightfulnessCriterion,
  LifecycleStage,
  MentionNotification,
  MentionNotificationResponse,
  NotificationProgress,
  Notifications,
  PaginatedAnswerOptionList,
  PaginatedAssessmentList,
  PaginatedCommentList,
  PaginatedCustomFieldDefinitionList,
  PaginatedCustomFieldValueReadList,
  PaginatedDepartmentList,
  PaginatedEnhancedGovernanceList,
  PaginatedEvidenceArtefactSerialiserList,
  PaginatedEvidenceSerialiserList,
  PaginatedFindingChangelogList,
  PaginatedFindingList,
  PaginatedGovernanceAnswerList,
  PaginatedInfoboxList,
  PaginatedInsightfulnessCriterionList,
  PaginatedLifecycleStageList,
  PaginatedNotificationsList,
  PaginatedPerformanceMetricList,
  PaginatedPerformanceMetricRankingList,
  PaginatedPersonalDataExposureCategoryList,
  PaginatedQuestionList,
  PaginatedReportTypeList,
  PaginatedRequirementTemplateList,
  PaginatedRichAiModelList,
  PaginatedRiskDimensionList,
  PaginatedRiskIndicatorList,
  PaginatedRiskIndicatorMetricResultsList,
  PaginatedRiskIndicatorTypeList,
  PaginatedRiskMetricList,
  PaginatedRiskMetricResultList,
  PaginatedSettingserializerList,
  PaginatedStyleCriterionList,
  PaginatedUseCaseListList,
  PaginatedViewSettingsList,
  PatchedAssessmentComment,
  PatchedComment,
  PatchedEvidenceArtefactSerialiser,
  PatchedEvidenceSerialiser,
  PatchedFindingWrite,
  PatchedGovernanceAnswer,
  PatchedLifecycleStage,
  PatchedPoorAiModel,
  PatchedRiskMetricResult,
  PatchedSettingserializer,
  PatchedStyleCriterion,
  PatchedUseCaseWrite,
  PatchedViewSettings,
  PerformanceMetric,
  PerformanceMetricRanking,
  PersonalDataExposureCategory,
  PoorAiModel,
  Question,
  ReportType,
  RequirementTemplate,
  RichAiModel,
  RiskDimension,
  RiskIndicator,
  RiskIndicatorMetricResults,
  RiskIndicatorType,
  RiskMetric,
  RiskMetricResult,
  Settingserializer,
  StyleCriterion,
  TextFieldTemplate,
  TreeMapResponse,
  UseCaseCount,
  UseCaseDetail,
  UseCaseName,
  UseCaseWrite,
  ViewSettings,
  WordExportParams,
} from '../models/index';
import {
  AiModelNameFromJSON,
  AiModelNameToJSON,
  AiModelStatusCountFromJSON,
  AiModelStatusCountToJSON,
  AnswerOptionFromJSON,
  AnswerOptionToJSON,
  AssessmentFromJSON,
  AssessmentToJSON,
  AssessmentCountFromJSON,
  AssessmentCountToJSON,
  AssessmentDetailFromJSON,
  AssessmentDetailToJSON,
  AssessmentResultsFromJSON,
  AssessmentResultsToJSON,
  AuxiliaryRiskMetricResultFromJSON,
  AuxiliaryRiskMetricResultToJSON,
  CommentFromJSON,
  CommentToJSON,
  ConciergeResultsAcceptedFromJSON,
  ConciergeResultsAcceptedToJSON,
  ConciergeResultsUploadFromJSON,
  ConciergeResultsUploadToJSON,
  CredentialReadFromJSON,
  CredentialReadToJSON,
  CredentialWriteFromJSON,
  CredentialWriteToJSON,
  CustomFieldDefinitionFromJSON,
  CustomFieldDefinitionToJSON,
  CustomFieldValueCreateFromJSON,
  CustomFieldValueCreateToJSON,
  CustomFieldValueReadFromJSON,
  CustomFieldValueReadToJSON,
  CustomFieldValueUpdateFromJSON,
  CustomFieldValueUpdateToJSON,
  DepartmentFromJSON,
  DepartmentToJSON,
  EnhancedGovernanceFromJSON,
  EnhancedGovernanceToJSON,
  EvidenceArtefactSerialiserFromJSON,
  EvidenceArtefactSerialiserToJSON,
  EvidenceSerialiserFromJSON,
  EvidenceSerialiserToJSON,
  FeatureFlagPayloadFromJSON,
  FeatureFlagPayloadToJSON,
  FindingFromJSON,
  FindingToJSON,
  FindingWriteFromJSON,
  FindingWriteToJSON,
  GovernanceAnswerFromJSON,
  GovernanceAnswerToJSON,
  GovernanceCustomQuestionnaireFromJSON,
  GovernanceCustomQuestionnaireToJSON,
  InfoboxFromJSON,
  InfoboxToJSON,
  InsightfulnessCriterionFromJSON,
  InsightfulnessCriterionToJSON,
  LifecycleStageFromJSON,
  LifecycleStageToJSON,
  MentionNotificationFromJSON,
  MentionNotificationToJSON,
  MentionNotificationResponseFromJSON,
  MentionNotificationResponseToJSON,
  NotificationProgressFromJSON,
  NotificationProgressToJSON,
  NotificationsFromJSON,
  NotificationsToJSON,
  PaginatedAnswerOptionListFromJSON,
  PaginatedAnswerOptionListToJSON,
  PaginatedAssessmentListFromJSON,
  PaginatedAssessmentListToJSON,
  PaginatedCommentListFromJSON,
  PaginatedCommentListToJSON,
  PaginatedCustomFieldDefinitionListFromJSON,
  PaginatedCustomFieldDefinitionListToJSON,
  PaginatedCustomFieldValueReadListFromJSON,
  PaginatedCustomFieldValueReadListToJSON,
  PaginatedDepartmentListFromJSON,
  PaginatedDepartmentListToJSON,
  PaginatedEnhancedGovernanceListFromJSON,
  PaginatedEnhancedGovernanceListToJSON,
  PaginatedEvidenceArtefactSerialiserListFromJSON,
  PaginatedEvidenceArtefactSerialiserListToJSON,
  PaginatedEvidenceSerialiserListFromJSON,
  PaginatedEvidenceSerialiserListToJSON,
  PaginatedFindingChangelogListFromJSON,
  PaginatedFindingChangelogListToJSON,
  PaginatedFindingListFromJSON,
  PaginatedFindingListToJSON,
  PaginatedGovernanceAnswerListFromJSON,
  PaginatedGovernanceAnswerListToJSON,
  PaginatedInfoboxListFromJSON,
  PaginatedInfoboxListToJSON,
  PaginatedInsightfulnessCriterionListFromJSON,
  PaginatedInsightfulnessCriterionListToJSON,
  PaginatedLifecycleStageListFromJSON,
  PaginatedLifecycleStageListToJSON,
  PaginatedNotificationsListFromJSON,
  PaginatedNotificationsListToJSON,
  PaginatedPerformanceMetricListFromJSON,
  PaginatedPerformanceMetricListToJSON,
  PaginatedPerformanceMetricRankingListFromJSON,
  PaginatedPerformanceMetricRankingListToJSON,
  PaginatedPersonalDataExposureCategoryListFromJSON,
  PaginatedPersonalDataExposureCategoryListToJSON,
  PaginatedQuestionListFromJSON,
  PaginatedQuestionListToJSON,
  PaginatedReportTypeListFromJSON,
  PaginatedReportTypeListToJSON,
  PaginatedRequirementTemplateListFromJSON,
  PaginatedRequirementTemplateListToJSON,
  PaginatedRichAiModelListFromJSON,
  PaginatedRichAiModelListToJSON,
  PaginatedRiskDimensionListFromJSON,
  PaginatedRiskDimensionListToJSON,
  PaginatedRiskIndicatorListFromJSON,
  PaginatedRiskIndicatorListToJSON,
  PaginatedRiskIndicatorMetricResultsListFromJSON,
  PaginatedRiskIndicatorMetricResultsListToJSON,
  PaginatedRiskIndicatorTypeListFromJSON,
  PaginatedRiskIndicatorTypeListToJSON,
  PaginatedRiskMetricListFromJSON,
  PaginatedRiskMetricListToJSON,
  PaginatedRiskMetricResultListFromJSON,
  PaginatedRiskMetricResultListToJSON,
  PaginatedSettingserializerListFromJSON,
  PaginatedSettingserializerListToJSON,
  PaginatedStyleCriterionListFromJSON,
  PaginatedStyleCriterionListToJSON,
  PaginatedUseCaseListListFromJSON,
  PaginatedUseCaseListListToJSON,
  PaginatedViewSettingsListFromJSON,
  PaginatedViewSettingsListToJSON,
  PatchedAssessmentCommentFromJSON,
  PatchedAssessmentCommentToJSON,
  PatchedCommentFromJSON,
  PatchedCommentToJSON,
  PatchedEvidenceArtefactSerialiserFromJSON,
  PatchedEvidenceArtefactSerialiserToJSON,
  PatchedEvidenceSerialiserFromJSON,
  PatchedEvidenceSerialiserToJSON,
  PatchedFindingWriteFromJSON,
  PatchedFindingWriteToJSON,
  PatchedGovernanceAnswerFromJSON,
  PatchedGovernanceAnswerToJSON,
  PatchedLifecycleStageFromJSON,
  PatchedLifecycleStageToJSON,
  PatchedPoorAiModelFromJSON,
  PatchedPoorAiModelToJSON,
  PatchedRiskMetricResultFromJSON,
  PatchedRiskMetricResultToJSON,
  PatchedSettingserializerFromJSON,
  PatchedSettingserializerToJSON,
  PatchedStyleCriterionFromJSON,
  PatchedStyleCriterionToJSON,
  PatchedUseCaseWriteFromJSON,
  PatchedUseCaseWriteToJSON,
  PatchedViewSettingsFromJSON,
  PatchedViewSettingsToJSON,
  PerformanceMetricFromJSON,
  PerformanceMetricToJSON,
  PerformanceMetricRankingFromJSON,
  PerformanceMetricRankingToJSON,
  PersonalDataExposureCategoryFromJSON,
  PersonalDataExposureCategoryToJSON,
  PoorAiModelFromJSON,
  PoorAiModelToJSON,
  QuestionFromJSON,
  QuestionToJSON,
  ReportTypeFromJSON,
  ReportTypeToJSON,
  RequirementTemplateFromJSON,
  RequirementTemplateToJSON,
  RichAiModelFromJSON,
  RichAiModelToJSON,
  RiskDimensionFromJSON,
  RiskDimensionToJSON,
  RiskIndicatorFromJSON,
  RiskIndicatorToJSON,
  RiskIndicatorMetricResultsFromJSON,
  RiskIndicatorMetricResultsToJSON,
  RiskIndicatorTypeFromJSON,
  RiskIndicatorTypeToJSON,
  RiskMetricFromJSON,
  RiskMetricToJSON,
  RiskMetricResultFromJSON,
  RiskMetricResultToJSON,
  SettingserializerFromJSON,
  SettingserializerToJSON,
  StyleCriterionFromJSON,
  StyleCriterionToJSON,
  TextFieldTemplateFromJSON,
  TextFieldTemplateToJSON,
  TreeMapResponseFromJSON,
  TreeMapResponseToJSON,
  UseCaseCountFromJSON,
  UseCaseCountToJSON,
  UseCaseDetailFromJSON,
  UseCaseDetailToJSON,
  UseCaseNameFromJSON,
  UseCaseNameToJSON,
  UseCaseWriteFromJSON,
  UseCaseWriteToJSON,
  ViewSettingsFromJSON,
  ViewSettingsToJSON,
  WordExportParamsFromJSON,
  WordExportParamsToJSON,
} from '../models/index';

export interface ApiAiModelLifecycleStageCreateRequest {
  lifecycleStage: Omit<LifecycleStage, 'id'>;
}

export interface ApiAiModelLifecycleStageDestroyRequest {
  id: number;
}

export interface ApiAiModelLifecycleStageListRequest {
  page?: number;
}

export interface ApiAiModelLifecycleStagePartialUpdateRequest {
  id: number;
  patchedLifecycleStage?: Omit<PatchedLifecycleStage, 'id'>;
}

export interface ApiAiModelLifecycleStageRetrieveRequest {
  id: number;
}

export interface ApiAiModelLifecycleStageUpdateRequest {
  id: number;
  lifecycleStage: Omit<LifecycleStage, 'id'>;
}

export interface ApiAiModelNamesListRequest {
  assessmentStatus?: Array<ApiAiModelNamesListAssessmentStatusEnum>;
  datasetInfo?: string;
  decomissionedOnAfter?: Date;
  decomissionedOnBefore?: Date;
  deploymentStatus?: Array<ApiAiModelNamesListDeploymentStatusEnum>;
  liveFromAfter?: Date;
  liveFromBefore?: Date;
  name?: string;
  taskType?: Array<ApiAiModelNamesListTaskTypeEnum>;
  technicalInfo?: string;
  technicalOwner?: string;
  useCase?: Array<string>;
}

export interface ApiAiModelsCreateRequest {
  poorAiModel: Omit<PoorAiModel, 'id' | 'useCase'>;
}

export interface ApiAiModelsDestroyRequest {
  id: number;
}

export interface ApiAiModelsListRequest {
  assessmentStatus?: Array<ApiAiModelsListAssessmentStatusEnum>;
  datasetInfo?: string;
  decomissionedOnAfter?: Date;
  decomissionedOnBefore?: Date;
  deploymentStatus?: Array<ApiAiModelsListDeploymentStatusEnum>;
  liveFromAfter?: Date;
  liveFromBefore?: Date;
  name?: string;
  page?: number;
  pageSize?: number;
  taskType?: Array<ApiAiModelsListTaskTypeEnum>;
  technicalInfo?: string;
  technicalOwner?: string;
  useCase?: Array<string>;
}

export interface ApiAiModelsPartialUpdateRequest {
  id: number;
  patchedPoorAiModel?: Omit<PatchedPoorAiModel, 'id' | 'useCase'>;
}

export interface ApiAiModelsRetrieveRequest {
  id: number;
}

export interface ApiAiModelsUpdateRequest {
  id: number;
  poorAiModel: Omit<PoorAiModel, 'id' | 'useCase'>;
}

export interface ApiAnswerOptionListRequest {
  page?: number;
}

export interface ApiAnswerOptionRetrieveRequest {
  id: number;
}

export interface ApiAssessmentResultsRetrieveRequest {
  modelid: string;
}

export interface ApiAssessmentsCreateRequest {
  assessment: Omit<
    Assessment,
    | 'id'
    | 'timestamp'
    | 'status'
    | 'progress'
    | 'startTime'
    | 'endTime'
    | 'estimatedTime'
    | 'elapsedTime'
    | 'aiModel'
    | 'datasetPipeline'
  >;
}

export interface ApiAssessmentsListRequest {
  aiModelTaskType?: Array<ApiAssessmentsListAiModelTaskTypeEnum>;
  datasetPipelineName?: string;
  endTimeAfter?: Date;
  endTimeBefore?: Date;
  id?: number;
  modelName?: Array<string>;
  ordering?: Array<ApiAssessmentsListOrderingEnum>;
  page?: number;
  pageSize?: number;
  startTimeAfter?: Date;
  startTimeBefore?: Date;
  status?: Array<ApiAssessmentsListStatusEnum>;
  timestampAfter?: Date;
  timestampBefore?: Date;
  useCaseId?: number;
}

export interface ApiAssessmentsPartialUpdateRequest {
  id: number;
  patchedAssessmentComment?: PatchedAssessmentComment;
}

export interface ApiAssessmentsRetrieveRequest {
  id: number;
}

export interface ApiAuxiliaryMetricResultsRetrieveRequest {
  id: number;
}

export interface ApiCommentsCreateRequest {
  comment: Omit<Comment, 'id' | 'user' | 'timestamp' | 'lastModified'>;
}

export interface ApiCommentsDestroyRequest {
  id: number;
}

export interface ApiCommentsListRequest {
  page?: number;
  useCase?: number;
  whichPage?: ApiCommentsListWhichPageEnum;
}

export interface ApiCommentsPartialUpdateRequest {
  id: number;
  patchedComment?: Omit<PatchedComment, 'id' | 'user' | 'timestamp' | 'lastModified'>;
}

export interface ApiCommentsRetrieveRequest {
  id: number;
}

export interface ApiCommentsUpdateRequest {
  id: number;
  comment: Omit<Comment, 'id' | 'user' | 'timestamp' | 'lastModified'>;
}

export interface ApiConciergeAssessmentsSubmitResultsCreateRequest {
  id: number;
  conciergeResultsUpload: ConciergeResultsUpload;
}

export interface ApiCredentialsCreateRequest {
  credentialWrite: CredentialWrite;
}

export interface ApiCredentialsListRequest {
  taskType?: Array<ApiCredentialsListTaskTypeEnum>;
  type?: Array<ApiCredentialsListTypeEnum>;
}

export interface ApiCredentialsRetrieveRequest {
  id: number;
}

export interface ApiCustomFieldDefinitionsListRequest {
  page?: number;
  pageSize?: number;
  targetModel?: ApiCustomFieldDefinitionsListTargetModelEnum;
}

export interface ApiCustomFieldDefinitionsRetrieveRequest {
  id: number;
}

export interface ApiCustomFieldValuesCreateRequest {
  field: number;
  useCase?: number | null;
  aiModel?: number | null;
  textValue?: string | null;
  fileValue?: Blob | null;
}

export interface ApiCustomFieldValuesDestroyRequest {
  id: string;
}

export interface ApiCustomFieldValuesListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiCustomFieldValuesPartialUpdateRequest {
  id: string;
  textValue?: string | null;
  fileValue?: Blob | null;
}

export interface ApiCustomFieldValuesRetrieveRequest {
  id: string;
}

export interface ApiCustomFieldValuesUpdateRequest {
  id: string;
  textValue?: string | null;
  fileValue?: Blob | null;
}

export interface ApiDepartmentsListRequest {
  page?: number;
}

export interface ApiDepartmentsRetrieveRequest {
  id: number;
}

export interface ApiDownloadRetrieveRequest {
  path: string;
}

export interface ApiDownloadS3PathRetrieveRequest {
  path: string;
}

export interface ApiExportWordCreateRequest {
  wordExportParams: WordExportParams;
}

export interface ApiFindingsChangelogListRequest {
  id: number;
  page?: number;
  riskIndicator?: number;
}

export interface ApiFindingsCreateRequest {
  findingWrite: FindingWrite;
}

export interface ApiFindingsDestroyRequest {
  id: number;
}

export interface ApiFindingsListRequest {
  page?: number;
  riskIndicator?: number;
}

export interface ApiFindingsPartialUpdateRequest {
  id: number;
  patchedFindingWrite?: PatchedFindingWrite;
}

export interface ApiFindingsRetrieveRequest {
  id: number;
}

export interface ApiFindingsUpdateRequest {
  id: number;
  findingWrite: FindingWrite;
}

export interface ApiGovernanceAnswerCreateRequest {
  governanceAnswer: Omit<GovernanceAnswer, 'id' | 'requirement' | 'evidence' | 'show'>;
}

export interface ApiGovernanceAnswerDestroyRequest {
  id: number;
}

export interface ApiGovernanceAnswerListRequest {
  page?: number;
  show?: boolean;
  useCase?: number;
}

export interface ApiGovernanceAnswerPartialUpdateRequest {
  id: number;
  patchedGovernanceAnswer?: Omit<PatchedGovernanceAnswer, 'id' | 'requirement' | 'evidence' | 'show'>;
}

export interface ApiGovernanceAnswerRetrieveRequest {
  id: number;
}

export interface ApiGovernanceAnswerUpdateRequest {
  id: number;
  governanceAnswer: Omit<GovernanceAnswer, 'id' | 'requirement' | 'evidence' | 'show'>;
}

export interface ApiGovernanceArtefactCreateRequest {
  evidenceArtefactSerialiser?: Omit<EvidenceArtefactSerialiser, 'id'>;
}

export interface ApiGovernanceArtefactDestroyRequest {
  id: number;
}

export interface ApiGovernanceArtefactListRequest {
  page?: number;
}

export interface ApiGovernanceArtefactPartialUpdateRequest {
  id: number;
  patchedEvidenceArtefactSerialiser?: Omit<PatchedEvidenceArtefactSerialiser, 'id'>;
}

export interface ApiGovernanceArtefactRetrieveRequest {
  id: number;
}

export interface ApiGovernanceArtefactUpdateRequest {
  id: number;
  evidenceArtefactSerialiser?: Omit<EvidenceArtefactSerialiser, 'id'>;
}

export interface ApiGovernanceEvidenceCreateRequest {
  evidenceSerialiser: Omit<EvidenceSerialiser, 'id'>;
}

export interface ApiGovernanceEvidenceDestroyRequest {
  id: number;
}

export interface ApiGovernanceEvidenceListRequest {
  page?: number;
}

export interface ApiGovernanceEvidencePartialUpdateRequest {
  id: number;
  patchedEvidenceSerialiser?: Omit<PatchedEvidenceSerialiser, 'id'>;
}

export interface ApiGovernanceEvidenceRetrieveRequest {
  id: number;
}

export interface ApiGovernanceEvidenceUpdateRequest {
  id: number;
  evidenceSerialiser: Omit<EvidenceSerialiser, 'id'>;
}

export interface ApiGovernanceListRequest {
  page?: number;
}

export interface ApiGovernanceRetrieveRequest {
  id: number;
}

export interface ApiInfoboxListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiInfoboxRetrieveRequest {
  id: number;
}

export interface ApiInsightfulnessCriteriaCreateRequest {
  insightfulnessCriterion: Omit<InsightfulnessCriterion, 'id'>;
}

export interface ApiInsightfulnessCriteriaListRequest {
  page?: number;
}

export interface ApiInsightfulnessCriteriaRetrieveRequest {
  id: number;
}

export interface ApiMentionNotificationCreateRequest {
  mentionNotification: MentionNotification;
}

export interface ApiNotificationsListRequest {
  ordering?: string;
  page?: number;
  search?: string;
  unread?: boolean;
}

export interface ApiNotificationsMarkAsReadCreateRequest {
  id: number;
}

export interface ApiNotificationsRetrieveRequest {
  id: number;
}

export interface ApiPerformanceMetricRankingsCreateRequest {
  performanceMetricRanking: Omit<PerformanceMetricRanking, 'id'>;
}

export interface ApiPerformanceMetricRankingsListRequest {
  page?: number;
}

export interface ApiPerformanceMetricRankingsRetrieveRequest {
  id: number;
}

export interface ApiPerformanceMetricsCreateRequest {
  performanceMetric: Omit<PerformanceMetric, 'id'>;
}

export interface ApiPerformanceMetricsListRequest {
  page?: number;
}

export interface ApiPerformanceMetricsRetrieveRequest {
  id: number;
}

export interface ApiPersonalDataExposureCategoriesListRequest {
  page?: number;
}

export interface ApiPersonalDataExposureCategoriesRetrieveRequest {
  id: number;
}

export interface ApiQuestionsListRequest {
  page?: number;
}

export interface ApiQuestionsRetrieveRequest {
  id: number;
}

export interface ApiReportTypesCreateRequest {
  reportType: Omit<ReportType, 'id'>;
}

export interface ApiReportTypesListRequest {
  page?: number;
}

export interface ApiReportTypesRetrieveRequest {
  id: number;
}

export interface ApiRequirementTemplatesCreateRequest {
  id: number;
  templateName: string;
  downloadUrl: string;
  requirement: number;
  customQuestionnaire: GovernanceCustomQuestionnaire;
  templateDescription?: string | null;
  templateType?: string;
  version?: string;
  isActive?: boolean;
}

export interface ApiRequirementTemplatesDestroyRequest {
  id: number;
}

export interface ApiRequirementTemplatesDownloadRetrieveRequest {
  id: number;
}

export interface ApiRequirementTemplatesListRequest {
  page?: number;
}

export interface ApiRequirementTemplatesPartialUpdateRequest {
  id: number;
  id2?: number;
  templateName?: string;
  templateDescription?: string | null;
  templateType?: string;
  version?: string;
  isActive?: boolean;
  downloadUrl?: string;
  requirement?: number;
  customQuestionnaire?: GovernanceCustomQuestionnaire;
}

export interface ApiRequirementTemplatesRetrieveRequest {
  id: number;
}

export interface ApiRequirementTemplatesUpdateRequest {
  id: number;
  id2: number;
  templateName: string;
  downloadUrl: string;
  requirement: number;
  customQuestionnaire: GovernanceCustomQuestionnaire;
  templateDescription?: string | null;
  templateType?: string;
  version?: string;
  isActive?: boolean;
}

export interface ApiRiskDimensionLabelNameListRequest {
  page?: number;
}

export interface ApiRiskDimensionLabelNameRetrieveRequest {
  id: number;
}

export interface ApiRiskIndicatorMetricResultsListRequest {
  aiModel?: number;
  aiModelNameIcontains?: string;
  page?: number;
}

export interface ApiRiskIndicatorMetricResultsRetrieveRequest {
  id: number;
}

export interface ApiRiskIndicatorTypesCreateRequest {
  riskIndicatorType: Omit<RiskIndicatorType, 'id' | 'riskMetrics'>;
  compact?: boolean;
}

export interface ApiRiskIndicatorTypesListRequest {
  compact?: boolean;
  page?: number;
}

export interface ApiRiskIndicatorTypesRetrieveRequest {
  id: number;
  compact?: boolean;
}

export interface ApiRiskIndicatorsListRequest {
  page?: number;
  search?: string;
}

export interface ApiRiskIndicatorsRetrieveRequest {
  id: number;
}

export interface ApiRiskMetricResultsListRequest {
  metricIndicator?: number;
  metricName?: string;
  page?: number;
  questionnaireId?: number;
  source?: number;
  sourceAiModel?: number;
}

export interface ApiRiskMetricResultsPartialUpdateRequest {
  id: number;
  patchedRiskMetricResult?: Omit<PatchedRiskMetricResult, 'id' | 'metric' | 'assessmentId'>;
}

export interface ApiRiskMetricResultsRetrieveRequest {
  id: number;
}

export interface ApiRiskMetricResultsUpdateRequest {
  id: number;
  riskMetricResult: Omit<RiskMetricResult, 'id' | 'metric' | 'assessmentId'>;
}

export interface ApiRiskMetricsListRequest {
  datasetPipelineId?: number;
  indicatorIn?: Array<number>;
  isActive?: boolean;
  page?: number;
  taskType?: ApiRiskMetricsListTaskTypeEnum;
}

export interface ApiRiskMetricsRetrieveRequest {
  id: number;
}

export interface ApiSchemaRetrieveRequest {
  format?: ApiSchemaRetrieveFormatEnum;
  lang?: ApiSchemaRetrieveLangEnum;
}

export interface ApiSettingsCreateRequest {
  settingserializer: Omit<Settingserializer, 'id'>;
}

export interface ApiSettingsDestroyRequest {
  id: number;
}

export interface ApiSettingsListRequest {
  page?: number;
}

export interface ApiSettingsPartialUpdateRequest {
  id: number;
  patchedSettingserializer?: Omit<PatchedSettingserializer, 'id'>;
}

export interface ApiSettingsRetrieveRequest {
  id: number;
}

export interface ApiSettingsUpdateRequest {
  id: number;
  settingserializer: Omit<Settingserializer, 'id'>;
}

export interface ApiStyleCriteriaCreateRequest {
  styleCriterion: Omit<StyleCriterion, 'id'>;
}

export interface ApiStyleCriteriaDestroyRequest {
  id: number;
}

export interface ApiStyleCriteriaListRequest {
  page?: number;
  taskType?: ApiStyleCriteriaListTaskTypeEnum;
}

export interface ApiStyleCriteriaPartialUpdateRequest {
  id: number;
  patchedStyleCriterion?: Omit<PatchedStyleCriterion, 'id'>;
}

export interface ApiStyleCriteriaRetrieveRequest {
  id: number;
}

export interface ApiStyleCriteriaUpdateRequest {
  id: number;
  styleCriterion: Omit<StyleCriterion, 'id'>;
}

export interface ApiTemplateDownloadRetrieveRequest {
  id: number;
}

export interface ApiTreemapRetrieveRequest {
  questionnaireId: number;
}

export interface ApiUseCaseNamesListRequest {
  aimodels?: Array<string>;
  businessOwner?: string;
  department?: Array<string>;
  description?: string;
  euAiActRiskClass?: Array<ApiUseCaseNamesListEuAiActRiskClassEnum>;
  materiality?: Array<ApiUseCaseNamesListMaterialityEnum>;
  name?: string;
  purpose?: string;
}

export interface ApiUseCasesCreateRequest {
  useCaseWrite: Omit<UseCaseWrite, 'id'>;
}

export interface ApiUseCasesDestroyRequest {
  id: number;
}

export interface ApiUseCasesListRequest {
  aimodels?: Array<string>;
  businessOwner?: string;
  department?: Array<string>;
  description?: string;
  euAiActRiskClass?: Array<ApiUseCasesListEuAiActRiskClassEnum>;
  materiality?: Array<ApiUseCasesListMaterialityEnum>;
  name?: string;
  page?: number;
  pageSize?: number;
  purpose?: string;
}

export interface ApiUseCasesPartialUpdateRequest {
  id: number;
  patchedUseCaseWrite?: Omit<PatchedUseCaseWrite, 'id'>;
}

export interface ApiUseCasesRetrieveRequest {
  id: number;
}

export interface ApiUseCasesShareTokenCreateRequest {
  id: number;
  useCaseWrite: Omit<UseCaseWrite, 'id'>;
}

export interface ApiUseCasesUpdateRequest {
  id: number;
  useCaseWrite: Omit<UseCaseWrite, 'id'>;
}

export interface ApiViewSettingsListRequest {
  page?: number;
}

export interface ApiViewSettingsPartialUpdateRequest {
  id: number;
  patchedViewSettings?: Omit<PatchedViewSettings, 'id'>;
}

export interface ApiViewSettingsRetrieveRequest {
  id: number;
}

/**
 *
 */
export class ApiApi extends runtime.BaseAPI {
  /**
   */
  async apiAiModelLifecycleStageCreateRaw(
    requestParameters: ApiAiModelLifecycleStageCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LifecycleStage>> {
    if (requestParameters['lifecycleStage'] == null) {
      throw new runtime.RequiredError(
        'lifecycleStage',
        'Required parameter "lifecycleStage" was null or undefined when calling apiAiModelLifecycleStageCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_model_lifecycle_stage/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: LifecycleStageToJSON(requestParameters['lifecycleStage']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => LifecycleStageFromJSON(jsonValue));
  }

  /**
   */
  async apiAiModelLifecycleStageCreate(
    requestParameters: ApiAiModelLifecycleStageCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LifecycleStage> {
    const response = await this.apiAiModelLifecycleStageCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiAiModelLifecycleStageDestroyRaw(
    requestParameters: ApiAiModelLifecycleStageDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiAiModelLifecycleStageDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_model_lifecycle_stage/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiAiModelLifecycleStageDestroy(
    requestParameters: ApiAiModelLifecycleStageDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiAiModelLifecycleStageDestroyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async apiAiModelLifecycleStageListRaw(
    requestParameters: ApiAiModelLifecycleStageListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedLifecycleStageList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_model_lifecycle_stage/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedLifecycleStageListFromJSON(jsonValue));
  }

  /**
   */
  async apiAiModelLifecycleStageList(
    requestParameters: ApiAiModelLifecycleStageListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedLifecycleStageList> {
    const response = await this.apiAiModelLifecycleStageListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiAiModelLifecycleStagePartialUpdateRaw(
    requestParameters: ApiAiModelLifecycleStagePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LifecycleStage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiAiModelLifecycleStagePartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_model_lifecycle_stage/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedLifecycleStageToJSON(requestParameters['patchedLifecycleStage']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => LifecycleStageFromJSON(jsonValue));
  }

  /**
   */
  async apiAiModelLifecycleStagePartialUpdate(
    requestParameters: ApiAiModelLifecycleStagePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LifecycleStage> {
    const response = await this.apiAiModelLifecycleStagePartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiAiModelLifecycleStageRetrieveRaw(
    requestParameters: ApiAiModelLifecycleStageRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LifecycleStage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiAiModelLifecycleStageRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_model_lifecycle_stage/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => LifecycleStageFromJSON(jsonValue));
  }

  /**
   */
  async apiAiModelLifecycleStageRetrieve(
    requestParameters: ApiAiModelLifecycleStageRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LifecycleStage> {
    const response = await this.apiAiModelLifecycleStageRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiAiModelLifecycleStageUpdateRaw(
    requestParameters: ApiAiModelLifecycleStageUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LifecycleStage>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiAiModelLifecycleStageUpdate().',
      );
    }

    if (requestParameters['lifecycleStage'] == null) {
      throw new runtime.RequiredError(
        'lifecycleStage',
        'Required parameter "lifecycleStage" was null or undefined when calling apiAiModelLifecycleStageUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_model_lifecycle_stage/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: LifecycleStageToJSON(requestParameters['lifecycleStage']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => LifecycleStageFromJSON(jsonValue));
  }

  /**
   */
  async apiAiModelLifecycleStageUpdate(
    requestParameters: ApiAiModelLifecycleStageUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LifecycleStage> {
    const response = await this.apiAiModelLifecycleStageUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiAiModelNamesListRaw(
    requestParameters: ApiAiModelNamesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<AiModelName>>> {
    const queryParameters: any = {};

    if (requestParameters['assessmentStatus'] != null) {
      queryParameters['assessment_status'] = requestParameters['assessmentStatus'];
    }

    if (requestParameters['datasetInfo'] != null) {
      queryParameters['dataset_info'] = requestParameters['datasetInfo'];
    }

    if (requestParameters['decomissionedOnAfter'] != null) {
      queryParameters['decomissioned_on_after'] = (requestParameters['decomissionedOnAfter'] as any)
        .toISOString()
        .substring(0, 10);
    }

    if (requestParameters['decomissionedOnBefore'] != null) {
      queryParameters['decomissioned_on_before'] = (requestParameters['decomissionedOnBefore'] as any)
        .toISOString()
        .substring(0, 10);
    }

    if (requestParameters['deploymentStatus'] != null) {
      queryParameters['deployment_status'] = requestParameters['deploymentStatus'];
    }

    if (requestParameters['liveFromAfter'] != null) {
      queryParameters['live_from_after'] = (requestParameters['liveFromAfter'] as any).toISOString().substring(0, 10);
    }

    if (requestParameters['liveFromBefore'] != null) {
      queryParameters['live_from_before'] = (requestParameters['liveFromBefore'] as any).toISOString().substring(0, 10);
    }

    if (requestParameters['name'] != null) {
      queryParameters['name'] = requestParameters['name'];
    }

    if (requestParameters['taskType'] != null) {
      queryParameters['task_type'] = requestParameters['taskType'];
    }

    if (requestParameters['technicalInfo'] != null) {
      queryParameters['technical_info'] = requestParameters['technicalInfo'];
    }

    if (requestParameters['technicalOwner'] != null) {
      queryParameters['technical_owner'] = requestParameters['technicalOwner'];
    }

    if (requestParameters['useCase'] != null) {
      queryParameters['use_case'] = requestParameters['useCase'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_model_names/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue.map(AiModelNameFromJSON));
  }

  /**
   */
  async apiAiModelNamesList(
    requestParameters: ApiAiModelNamesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<AiModelName>> {
    const response = await this.apiAiModelNamesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get the counts of models filter categories.  Each category is counted against a queryset that has every *other* active filter applied but not its own, so selecting an option never zeroes out the sibling options in the same category.
   */
  async apiAiModelsCountsRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AiModelStatusCount>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_models/counts/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => AiModelStatusCountFromJSON(jsonValue));
  }

  /**
   * Get the counts of models filter categories.  Each category is counted against a queryset that has every *other* active filter applied but not its own, so selecting an option never zeroes out the sibling options in the same category.
   */
  async apiAiModelsCountsRetrieve(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AiModelStatusCount> {
    const response = await this.apiAiModelsCountsRetrieveRaw(initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows AI models to be viewed or edited.
   */
  async apiAiModelsCreateRaw(
    requestParameters: ApiAiModelsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PoorAiModel>> {
    if (requestParameters['poorAiModel'] == null) {
      throw new runtime.RequiredError(
        'poorAiModel',
        'Required parameter "poorAiModel" was null or undefined when calling apiAiModelsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_models/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: PoorAiModelToJSON(requestParameters['poorAiModel']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PoorAiModelFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows AI models to be viewed or edited.
   */
  async apiAiModelsCreate(
    requestParameters: ApiAiModelsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PoorAiModel> {
    const response = await this.apiAiModelsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows AI models to be viewed or edited.
   */
  async apiAiModelsDestroyRaw(
    requestParameters: ApiAiModelsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiAiModelsDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_models/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint that allows AI models to be viewed or edited.
   */
  async apiAiModelsDestroy(
    requestParameters: ApiAiModelsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiAiModelsDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * API endpoint that allows AI models to be viewed or edited.
   */
  async apiAiModelsListRaw(
    requestParameters: ApiAiModelsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRichAiModelList>> {
    const queryParameters: any = {};

    if (requestParameters['assessmentStatus'] != null) {
      queryParameters['assessment_status'] = requestParameters['assessmentStatus'];
    }

    if (requestParameters['datasetInfo'] != null) {
      queryParameters['dataset_info'] = requestParameters['datasetInfo'];
    }

    if (requestParameters['decomissionedOnAfter'] != null) {
      queryParameters['decomissioned_on_after'] = (requestParameters['decomissionedOnAfter'] as any)
        .toISOString()
        .substring(0, 10);
    }

    if (requestParameters['decomissionedOnBefore'] != null) {
      queryParameters['decomissioned_on_before'] = (requestParameters['decomissionedOnBefore'] as any)
        .toISOString()
        .substring(0, 10);
    }

    if (requestParameters['deploymentStatus'] != null) {
      queryParameters['deployment_status'] = requestParameters['deploymentStatus'];
    }

    if (requestParameters['liveFromAfter'] != null) {
      queryParameters['live_from_after'] = (requestParameters['liveFromAfter'] as any).toISOString().substring(0, 10);
    }

    if (requestParameters['liveFromBefore'] != null) {
      queryParameters['live_from_before'] = (requestParameters['liveFromBefore'] as any).toISOString().substring(0, 10);
    }

    if (requestParameters['name'] != null) {
      queryParameters['name'] = requestParameters['name'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    if (requestParameters['taskType'] != null) {
      queryParameters['task_type'] = requestParameters['taskType'];
    }

    if (requestParameters['technicalInfo'] != null) {
      queryParameters['technical_info'] = requestParameters['technicalInfo'];
    }

    if (requestParameters['technicalOwner'] != null) {
      queryParameters['technical_owner'] = requestParameters['technicalOwner'];
    }

    if (requestParameters['useCase'] != null) {
      queryParameters['use_case'] = requestParameters['useCase'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_models/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRichAiModelListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows AI models to be viewed or edited.
   */
  async apiAiModelsList(
    requestParameters: ApiAiModelsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRichAiModelList> {
    const response = await this.apiAiModelsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows AI models to be viewed or edited.
   */
  async apiAiModelsPartialUpdateRaw(
    requestParameters: ApiAiModelsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PoorAiModel>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiAiModelsPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_models/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedPoorAiModelToJSON(requestParameters['patchedPoorAiModel']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PoorAiModelFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows AI models to be viewed or edited.
   */
  async apiAiModelsPartialUpdate(
    requestParameters: ApiAiModelsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PoorAiModel> {
    const response = await this.apiAiModelsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows AI models to be viewed or edited.
   */
  async apiAiModelsRetrieveRaw(
    requestParameters: ApiAiModelsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RichAiModel>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiAiModelsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_models/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RichAiModelFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows AI models to be viewed or edited.
   */
  async apiAiModelsRetrieve(
    requestParameters: ApiAiModelsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RichAiModel> {
    const response = await this.apiAiModelsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows AI models to be viewed or edited.
   */
  async apiAiModelsUpdateRaw(
    requestParameters: ApiAiModelsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PoorAiModel>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiAiModelsUpdate().',
      );
    }

    if (requestParameters['poorAiModel'] == null) {
      throw new runtime.RequiredError(
        'poorAiModel',
        'Required parameter "poorAiModel" was null or undefined when calling apiAiModelsUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/ai_models/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: PoorAiModelToJSON(requestParameters['poorAiModel']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PoorAiModelFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows AI models to be viewed or edited.
   */
  async apiAiModelsUpdate(
    requestParameters: ApiAiModelsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PoorAiModel> {
    const response = await this.apiAiModelsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows answer choices to be viewed (internal).
   */
  async apiAnswerOptionListRaw(
    requestParameters: ApiAnswerOptionListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedAnswerOptionList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/answer_option/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedAnswerOptionListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows answer choices to be viewed (internal).
   */
  async apiAnswerOptionList(
    requestParameters: ApiAnswerOptionListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedAnswerOptionList> {
    const response = await this.apiAnswerOptionListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows answer choices to be viewed (internal).
   */
  async apiAnswerOptionRetrieveRaw(
    requestParameters: ApiAnswerOptionRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AnswerOption>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiAnswerOptionRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/answer_option/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => AnswerOptionFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows answer choices to be viewed (internal).
   */
  async apiAnswerOptionRetrieve(
    requestParameters: ApiAnswerOptionRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AnswerOption> {
    const response = await this.apiAnswerOptionRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiAssessmentResultsRetrieveRaw(
    requestParameters: ApiAssessmentResultsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AssessmentResults>> {
    if (requestParameters['modelid'] == null) {
      throw new runtime.RequiredError(
        'modelid',
        'Required parameter "modelid" was null or undefined when calling apiAssessmentResultsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/assessment_results/{modelid}/`.replace(
          `{${'modelid'}}`,
          encodeURIComponent(String(requestParameters['modelid'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => AssessmentResultsFromJSON(jsonValue));
  }

  /**
   */
  async apiAssessmentResultsRetrieve(
    requestParameters: ApiAssessmentResultsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AssessmentResults> {
    const response = await this.apiAssessmentResultsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get the counts of assessments in different states.  Each category is counted against a queryset that has every *other* active filter applied but not its own, so selecting an option never zeroes out the sibling options in the same category.
   */
  async apiAssessmentsCountsRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AssessmentCount>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/assessments/counts/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => AssessmentCountFromJSON(jsonValue));
  }

  /**
   * Get the counts of assessments in different states.  Each category is counted against a queryset that has every *other* active filter applied but not its own, so selecting an option never zeroes out the sibling options in the same category.
   */
  async apiAssessmentsCountsRetrieve(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AssessmentCount> {
    const response = await this.apiAssessmentsCountsRetrieveRaw(initOverrides);
    return await response.value();
  }

  /**
   * Trigger an assessment for the selected Questionnaire Answer and Risk Metrics. Sends run to celery worker.
   */
  async apiAssessmentsCreateRaw(
    requestParameters: ApiAssessmentsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Assessment>> {
    if (requestParameters['assessment'] == null) {
      throw new runtime.RequiredError(
        'assessment',
        'Required parameter "assessment" was null or undefined when calling apiAssessmentsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/assessments/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: AssessmentToJSON(requestParameters['assessment']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => AssessmentFromJSON(jsonValue));
  }

  /**
   * Trigger an assessment for the selected Questionnaire Answer and Risk Metrics. Sends run to celery worker.
   */
  async apiAssessmentsCreate(
    requestParameters: ApiAssessmentsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Assessment> {
    const response = await this.apiAssessmentsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows assessments to be viewed. Its used to trigger the risk assessments.
   */
  async apiAssessmentsListRaw(
    requestParameters: ApiAssessmentsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedAssessmentList>> {
    const queryParameters: any = {};

    if (requestParameters['aiModelTaskType'] != null) {
      queryParameters['ai_model_task_type'] = requestParameters['aiModelTaskType'];
    }

    if (requestParameters['datasetPipelineName'] != null) {
      queryParameters['dataset_pipeline_name'] = requestParameters['datasetPipelineName'];
    }

    if (requestParameters['endTimeAfter'] != null) {
      queryParameters['end_time_after'] = (requestParameters['endTimeAfter'] as any).toISOString();
    }

    if (requestParameters['endTimeBefore'] != null) {
      queryParameters['end_time_before'] = (requestParameters['endTimeBefore'] as any).toISOString();
    }

    if (requestParameters['id'] != null) {
      queryParameters['id'] = requestParameters['id'];
    }

    if (requestParameters['modelName'] != null) {
      queryParameters['model_name'] = requestParameters['modelName'];
    }

    if (requestParameters['ordering'] != null) {
      queryParameters['ordering'] = requestParameters['ordering']!.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    if (requestParameters['startTimeAfter'] != null) {
      queryParameters['start_time_after'] = (requestParameters['startTimeAfter'] as any).toISOString();
    }

    if (requestParameters['startTimeBefore'] != null) {
      queryParameters['start_time_before'] = (requestParameters['startTimeBefore'] as any).toISOString();
    }

    if (requestParameters['status'] != null) {
      queryParameters['status'] = requestParameters['status'];
    }

    if (requestParameters['timestampAfter'] != null) {
      queryParameters['timestamp_after'] = (requestParameters['timestampAfter'] as any).toISOString();
    }

    if (requestParameters['timestampBefore'] != null) {
      queryParameters['timestamp_before'] = (requestParameters['timestampBefore'] as any).toISOString();
    }

    if (requestParameters['useCaseId'] != null) {
      queryParameters['useCaseId'] = requestParameters['useCaseId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/assessments/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedAssessmentListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows assessments to be viewed. Its used to trigger the risk assessments.
   */
  async apiAssessmentsList(
    requestParameters: ApiAssessmentsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedAssessmentList> {
    const response = await this.apiAssessmentsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows assessments to be viewed. Its used to trigger the risk assessments.
   */
  async apiAssessmentsLiveStatusRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<NotificationProgress>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/assessments/live_status/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => NotificationProgressFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows assessments to be viewed. Its used to trigger the risk assessments.
   */
  async apiAssessmentsLiveStatusRetrieve(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<NotificationProgress> {
    const response = await this.apiAssessmentsLiveStatusRetrieveRaw(initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows assessments to be viewed. Its used to trigger the risk assessments.
   */
  async apiAssessmentsPartialUpdateRaw(
    requestParameters: ApiAssessmentsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Assessment>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiAssessmentsPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/assessments/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedAssessmentCommentToJSON(requestParameters['patchedAssessmentComment']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => AssessmentFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows assessments to be viewed. Its used to trigger the risk assessments.
   */
  async apiAssessmentsPartialUpdate(
    requestParameters: ApiAssessmentsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Assessment> {
    const response = await this.apiAssessmentsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows assessments to be viewed. Its used to trigger the risk assessments.
   */
  async apiAssessmentsRetrieveRaw(
    requestParameters: ApiAssessmentsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AssessmentDetail>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiAssessmentsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/assessments/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => AssessmentDetailFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows assessments to be viewed. Its used to trigger the risk assessments.
   */
  async apiAssessmentsRetrieve(
    requestParameters: ApiAssessmentsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AssessmentDetail> {
    const response = await this.apiAssessmentsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Retrieve a single auxiliary metric result, including its `value` JSON.  The compact `risk_indicator_metric_results` payload only ships ids and names for auxiliary metrics; the front-end calls this endpoint when the user expands an auxiliary metric accordion in the assessment detail view.
   */
  async apiAuxiliaryMetricResultsRetrieveRaw(
    requestParameters: ApiAuxiliaryMetricResultsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AuxiliaryRiskMetricResult>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiAuxiliaryMetricResultsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/auxiliary_metric_results/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => AuxiliaryRiskMetricResultFromJSON(jsonValue));
  }

  /**
   * Retrieve a single auxiliary metric result, including its `value` JSON.  The compact `risk_indicator_metric_results` payload only ships ids and names for auxiliary metrics; the front-end calls this endpoint when the user expands an auxiliary metric accordion in the assessment detail view.
   */
  async apiAuxiliaryMetricResultsRetrieve(
    requestParameters: ApiAuxiliaryMetricResultsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AuxiliaryRiskMetricResult> {
    const response = await this.apiAuxiliaryMetricResultsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows comments to be viewed or edited.
   */
  async apiCommentsCreateRaw(
    requestParameters: ApiCommentsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Comment>> {
    if (requestParameters['comment'] == null) {
      throw new runtime.RequiredError(
        'comment',
        'Required parameter "comment" was null or undefined when calling apiCommentsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/comments/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CommentToJSON(requestParameters['comment']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CommentFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows comments to be viewed or edited.
   */
  async apiCommentsCreate(
    requestParameters: ApiCommentsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Comment> {
    const response = await this.apiCommentsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows comments to be viewed or edited.
   */
  async apiCommentsDestroyRaw(
    requestParameters: ApiCommentsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCommentsDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/comments/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint that allows comments to be viewed or edited.
   */
  async apiCommentsDestroy(
    requestParameters: ApiCommentsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiCommentsDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * API endpoint that allows comments to be viewed or edited.
   */
  async apiCommentsListRaw(
    requestParameters: ApiCommentsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedCommentList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['useCase'] != null) {
      queryParameters['use_case'] = requestParameters['useCase'];
    }

    if (requestParameters['whichPage'] != null) {
      queryParameters['which_page'] = requestParameters['whichPage'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/comments/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedCommentListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows comments to be viewed or edited.
   */
  async apiCommentsList(
    requestParameters: ApiCommentsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedCommentList> {
    const response = await this.apiCommentsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows comments to be viewed or edited.
   */
  async apiCommentsPartialUpdateRaw(
    requestParameters: ApiCommentsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Comment>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCommentsPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/comments/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedCommentToJSON(requestParameters['patchedComment']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CommentFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows comments to be viewed or edited.
   */
  async apiCommentsPartialUpdate(
    requestParameters: ApiCommentsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Comment> {
    const response = await this.apiCommentsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows comments to be viewed or edited.
   */
  async apiCommentsRetrieveRaw(
    requestParameters: ApiCommentsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Comment>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCommentsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/comments/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CommentFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows comments to be viewed or edited.
   */
  async apiCommentsRetrieve(
    requestParameters: ApiCommentsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Comment> {
    const response = await this.apiCommentsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows comments to be viewed or edited.
   */
  async apiCommentsUpdateRaw(
    requestParameters: ApiCommentsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Comment>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCommentsUpdate().',
      );
    }

    if (requestParameters['comment'] == null) {
      throw new runtime.RequiredError(
        'comment',
        'Required parameter "comment" was null or undefined when calling apiCommentsUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/comments/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CommentToJSON(requestParameters['comment']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CommentFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows comments to be viewed or edited.
   */
  async apiCommentsUpdate(
    requestParameters: ApiCommentsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Comment> {
    const response = await this.apiCommentsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Submit externally-computed results for concierge assessments.
   */
  async apiConciergeAssessmentsSubmitResultsCreateRaw(
    requestParameters: ApiConciergeAssessmentsSubmitResultsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConciergeResultsAccepted>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiConciergeAssessmentsSubmitResultsCreate().',
      );
    }

    if (requestParameters['conciergeResultsUpload'] == null) {
      throw new runtime.RequiredError(
        'conciergeResultsUpload',
        'Required parameter "conciergeResultsUpload" was null or undefined when calling apiConciergeAssessmentsSubmitResultsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/concierge_assessments/{id}/submit_results/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ConciergeResultsUploadToJSON(requestParameters['conciergeResultsUpload']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ConciergeResultsAcceptedFromJSON(jsonValue));
  }

  /**
   * Submit externally-computed results for concierge assessments.
   */
  async apiConciergeAssessmentsSubmitResultsCreate(
    requestParameters: ApiConciergeAssessmentsSubmitResultsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConciergeResultsAccepted> {
    const response = await this.apiConciergeAssessmentsSubmitResultsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * User credentials management endpoint
   */
  async apiCredentialsCreateRaw(
    requestParameters: ApiCredentialsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CredentialRead>> {
    if (requestParameters['credentialWrite'] == null) {
      throw new runtime.RequiredError(
        'credentialWrite',
        'Required parameter "credentialWrite" was null or undefined when calling apiCredentialsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/credentials/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CredentialWriteToJSON(requestParameters['credentialWrite']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CredentialReadFromJSON(jsonValue));
  }

  /**
   * User credentials management endpoint
   */
  async apiCredentialsCreate(
    requestParameters: ApiCredentialsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CredentialRead> {
    const response = await this.apiCredentialsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * User credentials management endpoint
   */
  async apiCredentialsListRaw(
    requestParameters: ApiCredentialsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CredentialRead>>> {
    const queryParameters: any = {};

    if (requestParameters['taskType'] != null) {
      queryParameters['task_type'] = requestParameters['taskType'];
    }

    if (requestParameters['type'] != null) {
      queryParameters['type'] = requestParameters['type'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/credentials/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue.map(CredentialReadFromJSON));
  }

  /**
   * User credentials management endpoint
   */
  async apiCredentialsList(
    requestParameters: ApiCredentialsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CredentialRead>> {
    const response = await this.apiCredentialsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * User credentials management endpoint
   */
  async apiCredentialsRetrieveRaw(
    requestParameters: ApiCredentialsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CredentialRead>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCredentialsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/credentials/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CredentialReadFromJSON(jsonValue));
  }

  /**
   * User credentials management endpoint
   */
  async apiCredentialsRetrieve(
    requestParameters: ApiCredentialsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CredentialRead> {
    const response = await this.apiCredentialsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiCsvExportRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/csv_export`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiCsvExportRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
    await this.apiCsvExportRetrieveRaw(initOverrides);
  }

  /**
   * Read-only API endpoint for custom field definitions. Regular users can view definitions to know which custom fields to display when creating/updating Use Cases and AI Models.
   */
  async apiCustomFieldDefinitionsListRaw(
    requestParameters: ApiCustomFieldDefinitionsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedCustomFieldDefinitionList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    if (requestParameters['targetModel'] != null) {
      queryParameters['target_model'] = requestParameters['targetModel'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_field_definitions/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedCustomFieldDefinitionListFromJSON(jsonValue));
  }

  /**
   * Read-only API endpoint for custom field definitions. Regular users can view definitions to know which custom fields to display when creating/updating Use Cases and AI Models.
   */
  async apiCustomFieldDefinitionsList(
    requestParameters: ApiCustomFieldDefinitionsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedCustomFieldDefinitionList> {
    const response = await this.apiCustomFieldDefinitionsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Read-only API endpoint for custom field definitions. Regular users can view definitions to know which custom fields to display when creating/updating Use Cases and AI Models.
   */
  async apiCustomFieldDefinitionsRetrieveRaw(
    requestParameters: ApiCustomFieldDefinitionsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomFieldDefinition>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCustomFieldDefinitionsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_field_definitions/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CustomFieldDefinitionFromJSON(jsonValue));
  }

  /**
   * Read-only API endpoint for custom field definitions. Regular users can view definitions to know which custom fields to display when creating/updating Use Cases and AI Models.
   */
  async apiCustomFieldDefinitionsRetrieve(
    requestParameters: ApiCustomFieldDefinitionsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomFieldDefinition> {
    const response = await this.apiCustomFieldDefinitionsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for managing custom field values.  POST accepts a single custom field value with: field (definition PK), one of use_case or ai_model (parent PK), and text_value or file_value.
   */
  async apiCustomFieldValuesCreateRaw(
    requestParameters: ApiCustomFieldValuesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomFieldValueCreate>> {
    if (requestParameters['field'] == null) {
      throw new runtime.RequiredError(
        'field',
        'Required parameter "field" was null or undefined when calling apiCustomFieldValuesCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['field'] != null) {
      formParams.append('field', requestParameters['field'] as any);
    }

    if (requestParameters['useCase'] != null) {
      formParams.append('use_case', requestParameters['useCase'] as any);
    }

    if (requestParameters['aiModel'] != null) {
      formParams.append('ai_model', requestParameters['aiModel'] as any);
    }

    if (requestParameters['textValue'] != null) {
      formParams.append('text_value', requestParameters['textValue'] as any);
    }

    if (requestParameters['fileValue'] != null) {
      formParams.append('file_value', requestParameters['fileValue'] as any);
    }

    const response = await this.request(
      {
        path: `/api/custom_field_values/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CustomFieldValueCreateFromJSON(jsonValue));
  }

  /**
   * API endpoint for managing custom field values.  POST accepts a single custom field value with: field (definition PK), one of use_case or ai_model (parent PK), and text_value or file_value.
   */
  async apiCustomFieldValuesCreate(
    requestParameters: ApiCustomFieldValuesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomFieldValueCreate> {
    const response = await this.apiCustomFieldValuesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for managing custom field values.  POST accepts a single custom field value with: field (definition PK), one of use_case or ai_model (parent PK), and text_value or file_value.
   */
  async apiCustomFieldValuesDestroyRaw(
    requestParameters: ApiCustomFieldValuesDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCustomFieldValuesDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_field_values/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint for managing custom field values.  POST accepts a single custom field value with: field (definition PK), one of use_case or ai_model (parent PK), and text_value or file_value.
   */
  async apiCustomFieldValuesDestroy(
    requestParameters: ApiCustomFieldValuesDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiCustomFieldValuesDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * API endpoint for managing custom field values.  POST accepts a single custom field value with: field (definition PK), one of use_case or ai_model (parent PK), and text_value or file_value.
   */
  async apiCustomFieldValuesListRaw(
    requestParameters: ApiCustomFieldValuesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedCustomFieldValueReadList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_field_values/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedCustomFieldValueReadListFromJSON(jsonValue));
  }

  /**
   * API endpoint for managing custom field values.  POST accepts a single custom field value with: field (definition PK), one of use_case or ai_model (parent PK), and text_value or file_value.
   */
  async apiCustomFieldValuesList(
    requestParameters: ApiCustomFieldValuesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedCustomFieldValueReadList> {
    const response = await this.apiCustomFieldValuesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for managing custom field values.  POST accepts a single custom field value with: field (definition PK), one of use_case or ai_model (parent PK), and text_value or file_value.
   */
  async apiCustomFieldValuesPartialUpdateRaw(
    requestParameters: ApiCustomFieldValuesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomFieldValueUpdate>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCustomFieldValuesPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['textValue'] != null) {
      formParams.append('text_value', requestParameters['textValue'] as any);
    }

    if (requestParameters['fileValue'] != null) {
      formParams.append('file_value', requestParameters['fileValue'] as any);
    }

    const response = await this.request(
      {
        path: `/api/custom_field_values/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CustomFieldValueUpdateFromJSON(jsonValue));
  }

  /**
   * API endpoint for managing custom field values.  POST accepts a single custom field value with: field (definition PK), one of use_case or ai_model (parent PK), and text_value or file_value.
   */
  async apiCustomFieldValuesPartialUpdate(
    requestParameters: ApiCustomFieldValuesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomFieldValueUpdate> {
    const response = await this.apiCustomFieldValuesPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for managing custom field values.  POST accepts a single custom field value with: field (definition PK), one of use_case or ai_model (parent PK), and text_value or file_value.
   */
  async apiCustomFieldValuesRetrieveRaw(
    requestParameters: ApiCustomFieldValuesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomFieldValueRead>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCustomFieldValuesRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_field_values/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CustomFieldValueReadFromJSON(jsonValue));
  }

  /**
   * API endpoint for managing custom field values.  POST accepts a single custom field value with: field (definition PK), one of use_case or ai_model (parent PK), and text_value or file_value.
   */
  async apiCustomFieldValuesRetrieve(
    requestParameters: ApiCustomFieldValuesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomFieldValueRead> {
    const response = await this.apiCustomFieldValuesRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for managing custom field values.  POST accepts a single custom field value with: field (definition PK), one of use_case or ai_model (parent PK), and text_value or file_value.
   */
  async apiCustomFieldValuesUpdateRaw(
    requestParameters: ApiCustomFieldValuesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomFieldValueUpdate>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCustomFieldValuesUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['textValue'] != null) {
      formParams.append('text_value', requestParameters['textValue'] as any);
    }

    if (requestParameters['fileValue'] != null) {
      formParams.append('file_value', requestParameters['fileValue'] as any);
    }

    const response = await this.request(
      {
        path: `/api/custom_field_values/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CustomFieldValueUpdateFromJSON(jsonValue));
  }

  /**
   * API endpoint for managing custom field values.  POST accepts a single custom field value with: field (definition PK), one of use_case or ai_model (parent PK), and text_value or file_value.
   */
  async apiCustomFieldValuesUpdate(
    requestParameters: ApiCustomFieldValuesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomFieldValueUpdate> {
    const response = await this.apiCustomFieldValuesUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows departments to be viewed.
   */
  async apiDepartmentsListRaw(
    requestParameters: ApiDepartmentsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedDepartmentList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/departments/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedDepartmentListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows departments to be viewed.
   */
  async apiDepartmentsList(
    requestParameters: ApiDepartmentsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedDepartmentList> {
    const response = await this.apiDepartmentsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows departments to be viewed.
   */
  async apiDepartmentsRetrieveRaw(
    requestParameters: ApiDepartmentsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Department>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDepartmentsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/departments/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DepartmentFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows departments to be viewed.
   */
  async apiDepartmentsRetrieve(
    requestParameters: ApiDepartmentsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Department> {
    const response = await this.apiDepartmentsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows files to be downloaded.
   */
  async apiDownloadRetrieveRaw(
    requestParameters: ApiDownloadRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['path'] == null) {
      throw new runtime.RequiredError(
        'path',
        'Required parameter "path" was null or undefined when calling apiDownloadRetrieve().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['path'] != null) {
      queryParameters['path'] = requestParameters['path'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/download/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint that allows files to be downloaded.
   */
  async apiDownloadRetrieve(
    requestParameters: ApiDownloadRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiDownloadRetrieveRaw(requestParameters, initOverrides);
  }

  /**
   * API endpoint that downloads a file from S3 given a full S3 path (e.g. s3://bucket/path/to/file).
   */
  async apiDownloadS3PathRetrieveRaw(
    requestParameters: ApiDownloadS3PathRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['path'] == null) {
      throw new runtime.RequiredError(
        'path',
        'Required parameter "path" was null or undefined when calling apiDownloadS3PathRetrieve().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['path'] != null) {
      queryParameters['path'] = requestParameters['path'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/download-s3-path/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint that downloads a file from S3 given a full S3 path (e.g. s3://bucket/path/to/file).
   */
  async apiDownloadS3PathRetrieve(
    requestParameters: ApiDownloadS3PathRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiDownloadS3PathRetrieveRaw(requestParameters, initOverrides);
  }

  /**
   */
  async apiExcelIndicatorsRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/excel/indicators`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiExcelIndicatorsRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
    await this.apiExcelIndicatorsRetrieveRaw(initOverrides);
  }

  /**
   */
  async apiExcelInventoriesRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/excel/inventories`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiExcelInventoriesRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
    await this.apiExcelInventoriesRetrieveRaw(initOverrides);
  }

  /**
   */
  async apiExportWordCreateRaw(
    requestParameters: ApiExportWordCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters['wordExportParams'] == null) {
      throw new runtime.RequiredError(
        'wordExportParams',
        'Required parameter "wordExportParams" was null or undefined when calling apiExportWordCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/export/word`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: WordExportParamsToJSON(requestParameters['wordExportParams']),
      },
      initOverrides,
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   */
  async apiExportWordCreate(
    requestParameters: ApiExportWordCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Blob> {
    const response = await this.apiExportWordCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiFeatureFlagsListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<FeatureFlagPayload>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/feature_flags/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => FeatureFlagPayloadFromJSON(jsonValue));
  }

  /**
   */
  async apiFeatureFlagsList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FeatureFlagPayload> {
    const response = await this.apiFeatureFlagsListRaw(initOverrides);
    return await response.value();
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsChangelogListRaw(
    requestParameters: ApiFindingsChangelogListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedFindingChangelogList>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiFindingsChangelogList().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['riskIndicator'] != null) {
      queryParameters['risk_indicator'] = requestParameters['riskIndicator'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/findings/{id}/changelog/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedFindingChangelogListFromJSON(jsonValue));
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsChangelogList(
    requestParameters: ApiFindingsChangelogListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedFindingChangelogList> {
    const response = await this.apiFindingsChangelogListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsCreateRaw(
    requestParameters: ApiFindingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Finding>> {
    if (requestParameters['findingWrite'] == null) {
      throw new runtime.RequiredError(
        'findingWrite',
        'Required parameter "findingWrite" was null or undefined when calling apiFindingsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/findings/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: FindingWriteToJSON(requestParameters['findingWrite']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => FindingFromJSON(jsonValue));
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsCreate(
    requestParameters: ApiFindingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Finding> {
    const response = await this.apiFindingsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsDestroyRaw(
    requestParameters: ApiFindingsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiFindingsDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/findings/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsDestroy(
    requestParameters: ApiFindingsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiFindingsDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsListRaw(
    requestParameters: ApiFindingsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedFindingList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['riskIndicator'] != null) {
      queryParameters['risk_indicator'] = requestParameters['riskIndicator'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/findings/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedFindingListFromJSON(jsonValue));
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsList(
    requestParameters: ApiFindingsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedFindingList> {
    const response = await this.apiFindingsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsPartialUpdateRaw(
    requestParameters: ApiFindingsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Finding>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiFindingsPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/findings/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedFindingWriteToJSON(requestParameters['patchedFindingWrite']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => FindingFromJSON(jsonValue));
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsPartialUpdate(
    requestParameters: ApiFindingsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Finding> {
    const response = await this.apiFindingsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsRetrieveRaw(
    requestParameters: ApiFindingsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Finding>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiFindingsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/findings/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => FindingFromJSON(jsonValue));
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsRetrieve(
    requestParameters: ApiFindingsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Finding> {
    const response = await this.apiFindingsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsUpdateRaw(
    requestParameters: ApiFindingsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Finding>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiFindingsUpdate().',
      );
    }

    if (requestParameters['findingWrite'] == null) {
      throw new runtime.RequiredError(
        'findingWrite',
        'Required parameter "findingWrite" was null or undefined when calling apiFindingsUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/findings/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: FindingWriteToJSON(requestParameters['findingWrite']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => FindingFromJSON(jsonValue));
  }

  /**
   * CRUD for findings. Findings can be auto-generated by the findings job or created manually via the API.
   */
  async apiFindingsUpdate(
    requestParameters: ApiFindingsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Finding> {
    const response = await this.apiFindingsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows to view, update and delete governance answers
   */
  async apiGovernanceAnswerCreateRaw(
    requestParameters: ApiGovernanceAnswerCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GovernanceAnswer>> {
    if (requestParameters['governanceAnswer'] == null) {
      throw new runtime.RequiredError(
        'governanceAnswer',
        'Required parameter "governanceAnswer" was null or undefined when calling apiGovernanceAnswerCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_answer/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: GovernanceAnswerToJSON(requestParameters['governanceAnswer']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => GovernanceAnswerFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows to view, update and delete governance answers
   */
  async apiGovernanceAnswerCreate(
    requestParameters: ApiGovernanceAnswerCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GovernanceAnswer> {
    const response = await this.apiGovernanceAnswerCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows to view, update and delete governance answers
   */
  async apiGovernanceAnswerDestroyRaw(
    requestParameters: ApiGovernanceAnswerDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceAnswerDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_answer/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint that allows to view, update and delete governance answers
   */
  async apiGovernanceAnswerDestroy(
    requestParameters: ApiGovernanceAnswerDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiGovernanceAnswerDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * API endpoint that allows to view, update and delete governance answers
   */
  async apiGovernanceAnswerListRaw(
    requestParameters: ApiGovernanceAnswerListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedGovernanceAnswerList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['show'] != null) {
      queryParameters['show'] = requestParameters['show'];
    }

    if (requestParameters['useCase'] != null) {
      queryParameters['use_case'] = requestParameters['useCase'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_answer/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedGovernanceAnswerListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows to view, update and delete governance answers
   */
  async apiGovernanceAnswerList(
    requestParameters: ApiGovernanceAnswerListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedGovernanceAnswerList> {
    const response = await this.apiGovernanceAnswerListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows to view, update and delete governance answers
   */
  async apiGovernanceAnswerPartialUpdateRaw(
    requestParameters: ApiGovernanceAnswerPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GovernanceAnswer>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceAnswerPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_answer/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedGovernanceAnswerToJSON(requestParameters['patchedGovernanceAnswer']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => GovernanceAnswerFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows to view, update and delete governance answers
   */
  async apiGovernanceAnswerPartialUpdate(
    requestParameters: ApiGovernanceAnswerPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GovernanceAnswer> {
    const response = await this.apiGovernanceAnswerPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows to view, update and delete governance answers
   */
  async apiGovernanceAnswerRetrieveRaw(
    requestParameters: ApiGovernanceAnswerRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GovernanceAnswer>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceAnswerRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_answer/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => GovernanceAnswerFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows to view, update and delete governance answers
   */
  async apiGovernanceAnswerRetrieve(
    requestParameters: ApiGovernanceAnswerRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GovernanceAnswer> {
    const response = await this.apiGovernanceAnswerRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows to view, update and delete governance answers
   */
  async apiGovernanceAnswerUpdateRaw(
    requestParameters: ApiGovernanceAnswerUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GovernanceAnswer>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceAnswerUpdate().',
      );
    }

    if (requestParameters['governanceAnswer'] == null) {
      throw new runtime.RequiredError(
        'governanceAnswer',
        'Required parameter "governanceAnswer" was null or undefined when calling apiGovernanceAnswerUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_answer/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: GovernanceAnswerToJSON(requestParameters['governanceAnswer']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => GovernanceAnswerFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows to view, update and delete governance answers
   */
  async apiGovernanceAnswerUpdate(
    requestParameters: ApiGovernanceAnswerUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GovernanceAnswer> {
    const response = await this.apiGovernanceAnswerUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceArtefactCreateRaw(
    requestParameters: ApiGovernanceArtefactCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EvidenceArtefactSerialiser>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_artefact/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: EvidenceArtefactSerialiserToJSON(requestParameters['evidenceArtefactSerialiser']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => EvidenceArtefactSerialiserFromJSON(jsonValue));
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceArtefactCreate(
    requestParameters: ApiGovernanceArtefactCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EvidenceArtefactSerialiser> {
    const response = await this.apiGovernanceArtefactCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceArtefactDestroyRaw(
    requestParameters: ApiGovernanceArtefactDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceArtefactDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_artefact/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceArtefactDestroy(
    requestParameters: ApiGovernanceArtefactDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiGovernanceArtefactDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceArtefactListRaw(
    requestParameters: ApiGovernanceArtefactListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedEvidenceArtefactSerialiserList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_artefact/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedEvidenceArtefactSerialiserListFromJSON(jsonValue),
    );
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceArtefactList(
    requestParameters: ApiGovernanceArtefactListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedEvidenceArtefactSerialiserList> {
    const response = await this.apiGovernanceArtefactListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceArtefactPartialUpdateRaw(
    requestParameters: ApiGovernanceArtefactPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EvidenceArtefactSerialiser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceArtefactPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_artefact/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedEvidenceArtefactSerialiserToJSON(requestParameters['patchedEvidenceArtefactSerialiser']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => EvidenceArtefactSerialiserFromJSON(jsonValue));
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceArtefactPartialUpdate(
    requestParameters: ApiGovernanceArtefactPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EvidenceArtefactSerialiser> {
    const response = await this.apiGovernanceArtefactPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceArtefactRetrieveRaw(
    requestParameters: ApiGovernanceArtefactRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EvidenceArtefactSerialiser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceArtefactRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_artefact/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => EvidenceArtefactSerialiserFromJSON(jsonValue));
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceArtefactRetrieve(
    requestParameters: ApiGovernanceArtefactRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EvidenceArtefactSerialiser> {
    const response = await this.apiGovernanceArtefactRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceArtefactUpdateRaw(
    requestParameters: ApiGovernanceArtefactUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EvidenceArtefactSerialiser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceArtefactUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_artefact/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: EvidenceArtefactSerialiserToJSON(requestParameters['evidenceArtefactSerialiser']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => EvidenceArtefactSerialiserFromJSON(jsonValue));
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceArtefactUpdate(
    requestParameters: ApiGovernanceArtefactUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EvidenceArtefactSerialiser> {
    const response = await this.apiGovernanceArtefactUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceEvidenceCreateRaw(
    requestParameters: ApiGovernanceEvidenceCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EvidenceSerialiser>> {
    if (requestParameters['evidenceSerialiser'] == null) {
      throw new runtime.RequiredError(
        'evidenceSerialiser',
        'Required parameter "evidenceSerialiser" was null or undefined when calling apiGovernanceEvidenceCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_evidence/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: EvidenceSerialiserToJSON(requestParameters['evidenceSerialiser']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => EvidenceSerialiserFromJSON(jsonValue));
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceEvidenceCreate(
    requestParameters: ApiGovernanceEvidenceCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EvidenceSerialiser> {
    const response = await this.apiGovernanceEvidenceCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceEvidenceDestroyRaw(
    requestParameters: ApiGovernanceEvidenceDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceEvidenceDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_evidence/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceEvidenceDestroy(
    requestParameters: ApiGovernanceEvidenceDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiGovernanceEvidenceDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceEvidenceListRaw(
    requestParameters: ApiGovernanceEvidenceListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedEvidenceSerialiserList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_evidence/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedEvidenceSerialiserListFromJSON(jsonValue));
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceEvidenceList(
    requestParameters: ApiGovernanceEvidenceListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedEvidenceSerialiserList> {
    const response = await this.apiGovernanceEvidenceListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceEvidencePartialUpdateRaw(
    requestParameters: ApiGovernanceEvidencePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EvidenceSerialiser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceEvidencePartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_evidence/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedEvidenceSerialiserToJSON(requestParameters['patchedEvidenceSerialiser']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => EvidenceSerialiserFromJSON(jsonValue));
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceEvidencePartialUpdate(
    requestParameters: ApiGovernanceEvidencePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EvidenceSerialiser> {
    const response = await this.apiGovernanceEvidencePartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceEvidenceRetrieveRaw(
    requestParameters: ApiGovernanceEvidenceRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EvidenceSerialiser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceEvidenceRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_evidence/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => EvidenceSerialiserFromJSON(jsonValue));
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceEvidenceRetrieve(
    requestParameters: ApiGovernanceEvidenceRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EvidenceSerialiser> {
    const response = await this.apiGovernanceEvidenceRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceEvidenceUpdateRaw(
    requestParameters: ApiGovernanceEvidenceUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EvidenceSerialiser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceEvidenceUpdate().',
      );
    }

    if (requestParameters['evidenceSerialiser'] == null) {
      throw new runtime.RequiredError(
        'evidenceSerialiser',
        'Required parameter "evidenceSerialiser" was null or undefined when calling apiGovernanceEvidenceUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance_evidence/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: EvidenceSerialiserToJSON(requestParameters['evidenceSerialiser']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => EvidenceSerialiserFromJSON(jsonValue));
  }

  /**
   * API endpoint to view, update and delete evidence
   */
  async apiGovernanceEvidenceUpdate(
    requestParameters: ApiGovernanceEvidenceUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EvidenceSerialiser> {
    const response = await this.apiGovernanceEvidenceUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows governance requirements to be viewed.
   */
  async apiGovernanceListRaw(
    requestParameters: ApiGovernanceListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedEnhancedGovernanceList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedEnhancedGovernanceListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows governance requirements to be viewed.
   */
  async apiGovernanceList(
    requestParameters: ApiGovernanceListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedEnhancedGovernanceList> {
    const response = await this.apiGovernanceListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows governance requirements to be viewed.
   */
  async apiGovernanceRetrieveRaw(
    requestParameters: ApiGovernanceRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EnhancedGovernance>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiGovernanceRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/governance/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => EnhancedGovernanceFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows governance requirements to be viewed.
   */
  async apiGovernanceRetrieve(
    requestParameters: ApiGovernanceRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EnhancedGovernance> {
    const response = await this.apiGovernanceRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows infoboxes in the platform to be viewed (internal).
   */
  async apiInfoboxListRaw(
    requestParameters: ApiInfoboxListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedInfoboxList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/infobox/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedInfoboxListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows infoboxes in the platform to be viewed (internal).
   */
  async apiInfoboxList(
    requestParameters: ApiInfoboxListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedInfoboxList> {
    const response = await this.apiInfoboxListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows infoboxes in the platform to be viewed (internal).
   */
  async apiInfoboxRetrieveRaw(
    requestParameters: ApiInfoboxRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Infobox>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInfoboxRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/infobox/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => InfoboxFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows infoboxes in the platform to be viewed (internal).
   */
  async apiInfoboxRetrieve(
    requestParameters: ApiInfoboxRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Infobox> {
    const response = await this.apiInfoboxRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Create a new insightfulness criterion. If a criterion with the same name already exists, return a message indicating that the name is already taken.
   */
  async apiInsightfulnessCriteriaCreateRaw(
    requestParameters: ApiInsightfulnessCriteriaCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InsightfulnessCriterion>> {
    if (requestParameters['insightfulnessCriterion'] == null) {
      throw new runtime.RequiredError(
        'insightfulnessCriterion',
        'Required parameter "insightfulnessCriterion" was null or undefined when calling apiInsightfulnessCriteriaCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/insightfulness_criteria/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: InsightfulnessCriterionToJSON(requestParameters['insightfulnessCriterion']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => InsightfulnessCriterionFromJSON(jsonValue));
  }

  /**
   * Create a new insightfulness criterion. If a criterion with the same name already exists, return a message indicating that the name is already taken.
   */
  async apiInsightfulnessCriteriaCreate(
    requestParameters: ApiInsightfulnessCriteriaCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InsightfulnessCriterion> {
    const response = await this.apiInsightfulnessCriteriaCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows insightfulness criteria to be viewed and created.
   */
  async apiInsightfulnessCriteriaListRaw(
    requestParameters: ApiInsightfulnessCriteriaListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedInsightfulnessCriterionList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/insightfulness_criteria/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedInsightfulnessCriterionListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows insightfulness criteria to be viewed and created.
   */
  async apiInsightfulnessCriteriaList(
    requestParameters: ApiInsightfulnessCriteriaListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedInsightfulnessCriterionList> {
    const response = await this.apiInsightfulnessCriteriaListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows insightfulness criteria to be viewed and created.
   */
  async apiInsightfulnessCriteriaRetrieveRaw(
    requestParameters: ApiInsightfulnessCriteriaRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InsightfulnessCriterion>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInsightfulnessCriteriaRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/insightfulness_criteria/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => InsightfulnessCriterionFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows insightfulness criteria to be viewed and created.
   */
  async apiInsightfulnessCriteriaRetrieve(
    requestParameters: ApiInsightfulnessCriteriaRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InsightfulnessCriterion> {
    const response = await this.apiInsightfulnessCriteriaRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiJsonExportRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/json_export`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiJsonExportRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
    await this.apiJsonExportRetrieveRaw(initOverrides);
  }

  /**
   * API endpoint to send mention notification email and create in-app notification for a user. Creates both an in-app notification and sends an email notification.
   */
  async apiMentionNotificationCreateRaw(
    requestParameters: ApiMentionNotificationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MentionNotificationResponse>> {
    if (requestParameters['mentionNotification'] == null) {
      throw new runtime.RequiredError(
        'mentionNotification',
        'Required parameter "mentionNotification" was null or undefined when calling apiMentionNotificationCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/mention-notification/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: MentionNotificationToJSON(requestParameters['mentionNotification']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => MentionNotificationResponseFromJSON(jsonValue));
  }

  /**
   * API endpoint to send mention notification email and create in-app notification for a user. Creates both an in-app notification and sends an email notification.
   */
  async apiMentionNotificationCreate(
    requestParameters: ApiMentionNotificationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MentionNotificationResponse> {
    const response = await this.apiMentionNotificationCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows notifications to be viewed or edited. Returns only notifications for the current authenticated user.
   */
  async apiNotificationsListRaw(
    requestParameters: ApiNotificationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedNotificationsList>> {
    const queryParameters: any = {};

    if (requestParameters['ordering'] != null) {
      queryParameters['ordering'] = requestParameters['ordering'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search'];
    }

    if (requestParameters['unread'] != null) {
      queryParameters['unread'] = requestParameters['unread'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/notifications/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedNotificationsListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows notifications to be viewed or edited. Returns only notifications for the current authenticated user.
   */
  async apiNotificationsList(
    requestParameters: ApiNotificationsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedNotificationsList> {
    const response = await this.apiNotificationsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows notifications to be viewed or edited. Returns only notifications for the current authenticated user.
   */
  async apiNotificationsMarkAsReadCreateRaw(
    requestParameters: ApiNotificationsMarkAsReadCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Notifications>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiNotificationsMarkAsReadCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/notifications/{id}/mark_as_read/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => NotificationsFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows notifications to be viewed or edited. Returns only notifications for the current authenticated user.
   */
  async apiNotificationsMarkAsReadCreate(
    requestParameters: ApiNotificationsMarkAsReadCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Notifications> {
    const response = await this.apiNotificationsMarkAsReadCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows notifications to be viewed or edited. Returns only notifications for the current authenticated user.
   */
  async apiNotificationsRetrieveRaw(
    requestParameters: ApiNotificationsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Notifications>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiNotificationsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/notifications/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => NotificationsFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows notifications to be viewed or edited. Returns only notifications for the current authenticated user.
   */
  async apiNotificationsRetrieve(
    requestParameters: ApiNotificationsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Notifications> {
    const response = await this.apiNotificationsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows performance metric rankings to be viewed or edited (internal).
   */
  async apiPerformanceMetricRankingsCreateRaw(
    requestParameters: ApiPerformanceMetricRankingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PerformanceMetricRanking>> {
    if (requestParameters['performanceMetricRanking'] == null) {
      throw new runtime.RequiredError(
        'performanceMetricRanking',
        'Required parameter "performanceMetricRanking" was null or undefined when calling apiPerformanceMetricRankingsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/performance_metric_rankings/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: PerformanceMetricRankingToJSON(requestParameters['performanceMetricRanking']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PerformanceMetricRankingFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows performance metric rankings to be viewed or edited (internal).
   */
  async apiPerformanceMetricRankingsCreate(
    requestParameters: ApiPerformanceMetricRankingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PerformanceMetricRanking> {
    const response = await this.apiPerformanceMetricRankingsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows performance metric rankings to be viewed or edited (internal).
   */
  async apiPerformanceMetricRankingsListRaw(
    requestParameters: ApiPerformanceMetricRankingsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedPerformanceMetricRankingList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/performance_metric_rankings/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedPerformanceMetricRankingListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows performance metric rankings to be viewed or edited (internal).
   */
  async apiPerformanceMetricRankingsList(
    requestParameters: ApiPerformanceMetricRankingsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedPerformanceMetricRankingList> {
    const response = await this.apiPerformanceMetricRankingsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows performance metric rankings to be viewed or edited (internal).
   */
  async apiPerformanceMetricRankingsRetrieveRaw(
    requestParameters: ApiPerformanceMetricRankingsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PerformanceMetricRanking>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiPerformanceMetricRankingsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/performance_metric_rankings/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PerformanceMetricRankingFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows performance metric rankings to be viewed or edited (internal).
   */
  async apiPerformanceMetricRankingsRetrieve(
    requestParameters: ApiPerformanceMetricRankingsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PerformanceMetricRanking> {
    const response = await this.apiPerformanceMetricRankingsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows performance metrics to be viewed or edited (internal).
   */
  async apiPerformanceMetricsCreateRaw(
    requestParameters: ApiPerformanceMetricsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PerformanceMetric>> {
    if (requestParameters['performanceMetric'] == null) {
      throw new runtime.RequiredError(
        'performanceMetric',
        'Required parameter "performanceMetric" was null or undefined when calling apiPerformanceMetricsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/performance_metrics/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: PerformanceMetricToJSON(requestParameters['performanceMetric']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PerformanceMetricFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows performance metrics to be viewed or edited (internal).
   */
  async apiPerformanceMetricsCreate(
    requestParameters: ApiPerformanceMetricsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PerformanceMetric> {
    const response = await this.apiPerformanceMetricsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows performance metrics to be viewed or edited (internal).
   */
  async apiPerformanceMetricsListRaw(
    requestParameters: ApiPerformanceMetricsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedPerformanceMetricList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/performance_metrics/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedPerformanceMetricListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows performance metrics to be viewed or edited (internal).
   */
  async apiPerformanceMetricsList(
    requestParameters: ApiPerformanceMetricsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedPerformanceMetricList> {
    const response = await this.apiPerformanceMetricsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows performance metrics to be viewed or edited (internal).
   */
  async apiPerformanceMetricsRetrieveRaw(
    requestParameters: ApiPerformanceMetricsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PerformanceMetric>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiPerformanceMetricsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/performance_metrics/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PerformanceMetricFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows performance metrics to be viewed or edited (internal).
   */
  async apiPerformanceMetricsRetrieve(
    requestParameters: ApiPerformanceMetricsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PerformanceMetric> {
    const response = await this.apiPerformanceMetricsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiPersonalDataExposureCategoriesListRaw(
    requestParameters: ApiPersonalDataExposureCategoriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedPersonalDataExposureCategoryList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/personal_data_exposure_categories/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedPersonalDataExposureCategoryListFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiPersonalDataExposureCategoriesList(
    requestParameters: ApiPersonalDataExposureCategoriesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedPersonalDataExposureCategoryList> {
    const response = await this.apiPersonalDataExposureCategoriesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiPersonalDataExposureCategoriesRetrieveRaw(
    requestParameters: ApiPersonalDataExposureCategoriesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PersonalDataExposureCategory>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiPersonalDataExposureCategoriesRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/personal_data_exposure_categories/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PersonalDataExposureCategoryFromJSON(jsonValue));
  }

  /**
   */
  async apiPersonalDataExposureCategoriesRetrieve(
    requestParameters: ApiPersonalDataExposureCategoriesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PersonalDataExposureCategory> {
    const response = await this.apiPersonalDataExposureCategoriesRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows questionnaire questions to be viewed (internal).
   */
  async apiQuestionsListRaw(
    requestParameters: ApiQuestionsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedQuestionList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/questions/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedQuestionListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows questionnaire questions to be viewed (internal).
   */
  async apiQuestionsList(
    requestParameters: ApiQuestionsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedQuestionList> {
    const response = await this.apiQuestionsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows questionnaire questions to be viewed (internal).
   */
  async apiQuestionsRetrieveRaw(
    requestParameters: ApiQuestionsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Question>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiQuestionsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/questions/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => QuestionFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows questionnaire questions to be viewed (internal).
   */
  async apiQuestionsRetrieve(
    requestParameters: ApiQuestionsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Question> {
    const response = await this.apiQuestionsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows report types to be viewed and created.
   */
  async apiReportTypesCreateRaw(
    requestParameters: ApiReportTypesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ReportType>> {
    if (requestParameters['reportType'] == null) {
      throw new runtime.RequiredError(
        'reportType',
        'Required parameter "reportType" was null or undefined when calling apiReportTypesCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/report_types/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ReportTypeToJSON(requestParameters['reportType']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ReportTypeFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows report types to be viewed and created.
   */
  async apiReportTypesCreate(
    requestParameters: ApiReportTypesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ReportType> {
    const response = await this.apiReportTypesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows report types to be viewed and created.
   */
  async apiReportTypesListRaw(
    requestParameters: ApiReportTypesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedReportTypeList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/report_types/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedReportTypeListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows report types to be viewed and created.
   */
  async apiReportTypesList(
    requestParameters: ApiReportTypesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedReportTypeList> {
    const response = await this.apiReportTypesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows report types to be viewed and created.
   */
  async apiReportTypesRetrieveRaw(
    requestParameters: ApiReportTypesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ReportType>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiReportTypesRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/report_types/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ReportTypeFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows report types to be viewed and created.
   */
  async apiReportTypesRetrieve(
    requestParameters: ApiReportTypesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ReportType> {
    const response = await this.apiReportTypesRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for managing requirement templates
   */
  async apiRequirementTemplatesCreateRaw(
    requestParameters: ApiRequirementTemplatesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RequirementTemplate>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRequirementTemplatesCreate().',
      );
    }

    if (requestParameters['templateName'] == null) {
      throw new runtime.RequiredError(
        'templateName',
        'Required parameter "templateName" was null or undefined when calling apiRequirementTemplatesCreate().',
      );
    }

    if (requestParameters['downloadUrl'] == null) {
      throw new runtime.RequiredError(
        'downloadUrl',
        'Required parameter "downloadUrl" was null or undefined when calling apiRequirementTemplatesCreate().',
      );
    }

    if (requestParameters['requirement'] == null) {
      throw new runtime.RequiredError(
        'requirement',
        'Required parameter "requirement" was null or undefined when calling apiRequirementTemplatesCreate().',
      );
    }

    if (requestParameters['customQuestionnaire'] == null) {
      throw new runtime.RequiredError(
        'customQuestionnaire',
        'Required parameter "customQuestionnaire" was null or undefined when calling apiRequirementTemplatesCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }, { contentType: 'application/json' }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['id'] != null) {
      formParams.append('id', requestParameters['id'] as any);
    }

    if (requestParameters['templateName'] != null) {
      formParams.append('template_name', requestParameters['templateName'] as any);
    }

    if (requestParameters['templateDescription'] != null) {
      formParams.append('template_description', requestParameters['templateDescription'] as any);
    }

    if (requestParameters['templateType'] != null) {
      formParams.append('template_type', requestParameters['templateType'] as any);
    }

    if (requestParameters['version'] != null) {
      formParams.append('version', requestParameters['version'] as any);
    }

    if (requestParameters['isActive'] != null) {
      formParams.append('is_active', requestParameters['isActive'] as any);
    }

    if (requestParameters['downloadUrl'] != null) {
      formParams.append('download_url', requestParameters['downloadUrl'] as any);
    }

    if (requestParameters['requirement'] != null) {
      formParams.append('requirement', requestParameters['requirement'] as any);
    }

    if (requestParameters['customQuestionnaire'] != null) {
      formParams.append(
        'custom_questionnaire',
        new Blob([JSON.stringify(GovernanceCustomQuestionnaireToJSON(requestParameters['customQuestionnaire']))], {
          type: 'application/json',
        }),
      );
    }

    const response = await this.request(
      {
        path: `/api/requirement_templates/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RequirementTemplateFromJSON(jsonValue));
  }

  /**
   * API endpoint for managing requirement templates
   */
  async apiRequirementTemplatesCreate(
    requestParameters: ApiRequirementTemplatesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RequirementTemplate> {
    const response = await this.apiRequirementTemplatesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for managing requirement templates
   */
  async apiRequirementTemplatesDestroyRaw(
    requestParameters: ApiRequirementTemplatesDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRequirementTemplatesDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/requirement_templates/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint for managing requirement templates
   */
  async apiRequirementTemplatesDestroy(
    requestParameters: ApiRequirementTemplatesDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiRequirementTemplatesDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * Download template file
   */
  async apiRequirementTemplatesDownloadRetrieveRaw(
    requestParameters: ApiRequirementTemplatesDownloadRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RequirementTemplate>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRequirementTemplatesDownloadRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/requirement_templates/{id}/download/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RequirementTemplateFromJSON(jsonValue));
  }

  /**
   * Download template file
   */
  async apiRequirementTemplatesDownloadRetrieve(
    requestParameters: ApiRequirementTemplatesDownloadRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RequirementTemplate> {
    const response = await this.apiRequirementTemplatesDownloadRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for managing requirement templates
   */
  async apiRequirementTemplatesListRaw(
    requestParameters: ApiRequirementTemplatesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRequirementTemplateList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/requirement_templates/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRequirementTemplateListFromJSON(jsonValue));
  }

  /**
   * API endpoint for managing requirement templates
   */
  async apiRequirementTemplatesList(
    requestParameters: ApiRequirementTemplatesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRequirementTemplateList> {
    const response = await this.apiRequirementTemplatesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for managing requirement templates
   */
  async apiRequirementTemplatesPartialUpdateRaw(
    requestParameters: ApiRequirementTemplatesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RequirementTemplate>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRequirementTemplatesPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }, { contentType: 'application/json' }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['id2'] != null) {
      formParams.append('id', requestParameters['id2'] as any);
    }

    if (requestParameters['templateName'] != null) {
      formParams.append('template_name', requestParameters['templateName'] as any);
    }

    if (requestParameters['templateDescription'] != null) {
      formParams.append('template_description', requestParameters['templateDescription'] as any);
    }

    if (requestParameters['templateType'] != null) {
      formParams.append('template_type', requestParameters['templateType'] as any);
    }

    if (requestParameters['version'] != null) {
      formParams.append('version', requestParameters['version'] as any);
    }

    if (requestParameters['isActive'] != null) {
      formParams.append('is_active', requestParameters['isActive'] as any);
    }

    if (requestParameters['downloadUrl'] != null) {
      formParams.append('download_url', requestParameters['downloadUrl'] as any);
    }

    if (requestParameters['requirement'] != null) {
      formParams.append('requirement', requestParameters['requirement'] as any);
    }

    if (requestParameters['customQuestionnaire'] != null) {
      formParams.append(
        'custom_questionnaire',
        new Blob([JSON.stringify(GovernanceCustomQuestionnaireToJSON(requestParameters['customQuestionnaire']))], {
          type: 'application/json',
        }),
      );
    }

    const response = await this.request(
      {
        path: `/api/requirement_templates/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RequirementTemplateFromJSON(jsonValue));
  }

  /**
   * API endpoint for managing requirement templates
   */
  async apiRequirementTemplatesPartialUpdate(
    requestParameters: ApiRequirementTemplatesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RequirementTemplate> {
    const response = await this.apiRequirementTemplatesPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for managing requirement templates
   */
  async apiRequirementTemplatesRetrieveRaw(
    requestParameters: ApiRequirementTemplatesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RequirementTemplate>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRequirementTemplatesRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/requirement_templates/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RequirementTemplateFromJSON(jsonValue));
  }

  /**
   * API endpoint for managing requirement templates
   */
  async apiRequirementTemplatesRetrieve(
    requestParameters: ApiRequirementTemplatesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RequirementTemplate> {
    const response = await this.apiRequirementTemplatesRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for managing requirement templates
   */
  async apiRequirementTemplatesUpdateRaw(
    requestParameters: ApiRequirementTemplatesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RequirementTemplate>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRequirementTemplatesUpdate().',
      );
    }

    if (requestParameters['id2'] == null) {
      throw new runtime.RequiredError(
        'id2',
        'Required parameter "id2" was null or undefined when calling apiRequirementTemplatesUpdate().',
      );
    }

    if (requestParameters['templateName'] == null) {
      throw new runtime.RequiredError(
        'templateName',
        'Required parameter "templateName" was null or undefined when calling apiRequirementTemplatesUpdate().',
      );
    }

    if (requestParameters['downloadUrl'] == null) {
      throw new runtime.RequiredError(
        'downloadUrl',
        'Required parameter "downloadUrl" was null or undefined when calling apiRequirementTemplatesUpdate().',
      );
    }

    if (requestParameters['requirement'] == null) {
      throw new runtime.RequiredError(
        'requirement',
        'Required parameter "requirement" was null or undefined when calling apiRequirementTemplatesUpdate().',
      );
    }

    if (requestParameters['customQuestionnaire'] == null) {
      throw new runtime.RequiredError(
        'customQuestionnaire',
        'Required parameter "customQuestionnaire" was null or undefined when calling apiRequirementTemplatesUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }, { contentType: 'application/json' }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['id2'] != null) {
      formParams.append('id', requestParameters['id2'] as any);
    }

    if (requestParameters['templateName'] != null) {
      formParams.append('template_name', requestParameters['templateName'] as any);
    }

    if (requestParameters['templateDescription'] != null) {
      formParams.append('template_description', requestParameters['templateDescription'] as any);
    }

    if (requestParameters['templateType'] != null) {
      formParams.append('template_type', requestParameters['templateType'] as any);
    }

    if (requestParameters['version'] != null) {
      formParams.append('version', requestParameters['version'] as any);
    }

    if (requestParameters['isActive'] != null) {
      formParams.append('is_active', requestParameters['isActive'] as any);
    }

    if (requestParameters['downloadUrl'] != null) {
      formParams.append('download_url', requestParameters['downloadUrl'] as any);
    }

    if (requestParameters['requirement'] != null) {
      formParams.append('requirement', requestParameters['requirement'] as any);
    }

    if (requestParameters['customQuestionnaire'] != null) {
      formParams.append(
        'custom_questionnaire',
        new Blob([JSON.stringify(GovernanceCustomQuestionnaireToJSON(requestParameters['customQuestionnaire']))], {
          type: 'application/json',
        }),
      );
    }

    const response = await this.request(
      {
        path: `/api/requirement_templates/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RequirementTemplateFromJSON(jsonValue));
  }

  /**
   * API endpoint for managing requirement templates
   */
  async apiRequirementTemplatesUpdate(
    requestParameters: ApiRequirementTemplatesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RequirementTemplate> {
    const response = await this.apiRequirementTemplatesUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows governance requirements to be viewed.
   */
  async apiRiskDimensionLabelNameListRaw(
    requestParameters: ApiRiskDimensionLabelNameListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRiskDimensionList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_dimension_label_name/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRiskDimensionListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows governance requirements to be viewed.
   */
  async apiRiskDimensionLabelNameList(
    requestParameters: ApiRiskDimensionLabelNameListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRiskDimensionList> {
    const response = await this.apiRiskDimensionLabelNameListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows governance requirements to be viewed.
   */
  async apiRiskDimensionLabelNameRetrieveRaw(
    requestParameters: ApiRiskDimensionLabelNameRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskDimension>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskDimensionLabelNameRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_dimension_label_name/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskDimensionFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows governance requirements to be viewed.
   */
  async apiRiskDimensionLabelNameRetrieve(
    requestParameters: ApiRiskDimensionLabelNameRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskDimension> {
    const response = await this.apiRiskDimensionLabelNameRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows risk indicator metric results to be viewed (internal).
   */
  async apiRiskIndicatorMetricResultsListRaw(
    requestParameters: ApiRiskIndicatorMetricResultsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRiskIndicatorMetricResultsList>> {
    const queryParameters: any = {};

    if (requestParameters['aiModel'] != null) {
      queryParameters['ai_model'] = requestParameters['aiModel'];
    }

    if (requestParameters['aiModelNameIcontains'] != null) {
      queryParameters['ai_model__name__icontains'] = requestParameters['aiModelNameIcontains'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_indicator_metric_results/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedRiskIndicatorMetricResultsListFromJSON(jsonValue),
    );
  }

  /**
   * API endpoint that allows risk indicator metric results to be viewed (internal).
   */
  async apiRiskIndicatorMetricResultsList(
    requestParameters: ApiRiskIndicatorMetricResultsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRiskIndicatorMetricResultsList> {
    const response = await this.apiRiskIndicatorMetricResultsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows risk indicator metric results to be viewed (internal).
   */
  async apiRiskIndicatorMetricResultsRetrieveRaw(
    requestParameters: ApiRiskIndicatorMetricResultsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskIndicatorMetricResults>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskIndicatorMetricResultsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_indicator_metric_results/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskIndicatorMetricResultsFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows risk indicator metric results to be viewed (internal).
   */
  async apiRiskIndicatorMetricResultsRetrieve(
    requestParameters: ApiRiskIndicatorMetricResultsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskIndicatorMetricResults> {
    const response = await this.apiRiskIndicatorMetricResultsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows risk indicator types to be viewed or edited.
   */
  async apiRiskIndicatorTypesCreateRaw(
    requestParameters: ApiRiskIndicatorTypesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskIndicatorType>> {
    if (requestParameters['riskIndicatorType'] == null) {
      throw new runtime.RequiredError(
        'riskIndicatorType',
        'Required parameter "riskIndicatorType" was null or undefined when calling apiRiskIndicatorTypesCreate().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['compact'] != null) {
      queryParameters['compact'] = requestParameters['compact'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_indicator_types/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RiskIndicatorTypeToJSON(requestParameters['riskIndicatorType']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskIndicatorTypeFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows risk indicator types to be viewed or edited.
   */
  async apiRiskIndicatorTypesCreate(
    requestParameters: ApiRiskIndicatorTypesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskIndicatorType> {
    const response = await this.apiRiskIndicatorTypesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows risk indicator types to be viewed or edited.
   */
  async apiRiskIndicatorTypesListRaw(
    requestParameters: ApiRiskIndicatorTypesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRiskIndicatorTypeList>> {
    const queryParameters: any = {};

    if (requestParameters['compact'] != null) {
      queryParameters['compact'] = requestParameters['compact'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_indicator_types/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRiskIndicatorTypeListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows risk indicator types to be viewed or edited.
   */
  async apiRiskIndicatorTypesList(
    requestParameters: ApiRiskIndicatorTypesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRiskIndicatorTypeList> {
    const response = await this.apiRiskIndicatorTypesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows risk indicator types to be viewed or edited.
   */
  async apiRiskIndicatorTypesRetrieveRaw(
    requestParameters: ApiRiskIndicatorTypesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskIndicatorType>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskIndicatorTypesRetrieve().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['compact'] != null) {
      queryParameters['compact'] = requestParameters['compact'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_indicator_types/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskIndicatorTypeFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows risk indicator types to be viewed or edited.
   */
  async apiRiskIndicatorTypesRetrieve(
    requestParameters: ApiRiskIndicatorTypesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskIndicatorType> {
    const response = await this.apiRiskIndicatorTypesRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows risk indicators to be viewed.
   */
  async apiRiskIndicatorsListRaw(
    requestParameters: ApiRiskIndicatorsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRiskIndicatorList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_indicators/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRiskIndicatorListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows risk indicators to be viewed.
   */
  async apiRiskIndicatorsList(
    requestParameters: ApiRiskIndicatorsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRiskIndicatorList> {
    const response = await this.apiRiskIndicatorsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows risk indicators to be viewed.
   */
  async apiRiskIndicatorsRetrieveRaw(
    requestParameters: ApiRiskIndicatorsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskIndicator>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskIndicatorsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_indicators/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskIndicatorFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows risk indicators to be viewed.
   */
  async apiRiskIndicatorsRetrieve(
    requestParameters: ApiRiskIndicatorsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskIndicator> {
    const response = await this.apiRiskIndicatorsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRiskMetricResultsListRaw(
    requestParameters: ApiRiskMetricResultsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRiskMetricResultList>> {
    const queryParameters: any = {};

    if (requestParameters['metricIndicator'] != null) {
      queryParameters['metric__indicator'] = requestParameters['metricIndicator'];
    }

    if (requestParameters['metricName'] != null) {
      queryParameters['metric__name'] = requestParameters['metricName'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['questionnaireId'] != null) {
      queryParameters['questionnaire_id'] = requestParameters['questionnaireId'];
    }

    if (requestParameters['source'] != null) {
      queryParameters['source'] = requestParameters['source'];
    }

    if (requestParameters['sourceAiModel'] != null) {
      queryParameters['source__ai_model'] = requestParameters['sourceAiModel'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_metric_results/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRiskMetricResultListFromJSON(jsonValue));
  }

  /**
   */
  async apiRiskMetricResultsList(
    requestParameters: ApiRiskMetricResultsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRiskMetricResultList> {
    const response = await this.apiRiskMetricResultsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRiskMetricResultsPartialUpdateRaw(
    requestParameters: ApiRiskMetricResultsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskMetricResult>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskMetricResultsPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_metric_results/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedRiskMetricResultToJSON(requestParameters['patchedRiskMetricResult']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskMetricResultFromJSON(jsonValue));
  }

  /**
   */
  async apiRiskMetricResultsPartialUpdate(
    requestParameters: ApiRiskMetricResultsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskMetricResult> {
    const response = await this.apiRiskMetricResultsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRiskMetricResultsRetrieveRaw(
    requestParameters: ApiRiskMetricResultsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskMetricResult>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskMetricResultsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_metric_results/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskMetricResultFromJSON(jsonValue));
  }

  /**
   */
  async apiRiskMetricResultsRetrieve(
    requestParameters: ApiRiskMetricResultsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskMetricResult> {
    const response = await this.apiRiskMetricResultsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRiskMetricResultsUpdateRaw(
    requestParameters: ApiRiskMetricResultsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskMetricResult>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskMetricResultsUpdate().',
      );
    }

    if (requestParameters['riskMetricResult'] == null) {
      throw new runtime.RequiredError(
        'riskMetricResult',
        'Required parameter "riskMetricResult" was null or undefined when calling apiRiskMetricResultsUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_metric_results/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RiskMetricResultToJSON(requestParameters['riskMetricResult']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskMetricResultFromJSON(jsonValue));
  }

  /**
   */
  async apiRiskMetricResultsUpdate(
    requestParameters: ApiRiskMetricResultsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskMetricResult> {
    const response = await this.apiRiskMetricResultsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows risk metrics to be viewed.
   */
  async apiRiskMetricsListRaw(
    requestParameters: ApiRiskMetricsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRiskMetricList>> {
    const queryParameters: any = {};

    if (requestParameters['datasetPipelineId'] != null) {
      queryParameters['dataset_pipeline_id'] = requestParameters['datasetPipelineId'];
    }

    if (requestParameters['indicatorIn'] != null) {
      queryParameters['indicator__in'] = requestParameters['indicatorIn']!.join(runtime.COLLECTION_FORMATS['csv']);
    }

    if (requestParameters['isActive'] != null) {
      queryParameters['is_active'] = requestParameters['isActive'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['taskType'] != null) {
      queryParameters['task_type'] = requestParameters['taskType'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_metrics/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRiskMetricListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows risk metrics to be viewed.
   */
  async apiRiskMetricsList(
    requestParameters: ApiRiskMetricsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRiskMetricList> {
    const response = await this.apiRiskMetricsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows risk metrics to be viewed.
   */
  async apiRiskMetricsRetrieveRaw(
    requestParameters: ApiRiskMetricsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskMetric>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskMetricsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_metrics/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskMetricFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows risk metrics to be viewed.
   */
  async apiRiskMetricsRetrieve(
    requestParameters: ApiRiskMetricsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskMetric> {
    const response = await this.apiRiskMetricsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
   */
  async apiSchemaRetrieveRaw(
    requestParameters: ApiSchemaRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<{ [key: string]: any }>> {
    const queryParameters: any = {};

    if (requestParameters['format'] != null) {
      queryParameters['format'] = requestParameters['format'];
    }

    if (requestParameters['lang'] != null) {
      queryParameters['lang'] = requestParameters['lang'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/schema/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
   */
  async apiSchemaRetrieve(
    requestParameters: ApiSchemaRetrieveRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: any }> {
    const response = await this.apiSchemaRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows settings (risk thresholds) to be viewed or edited.
   */
  async apiSettingsCreateRaw(
    requestParameters: ApiSettingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Settingserializer>> {
    if (requestParameters['settingserializer'] == null) {
      throw new runtime.RequiredError(
        'settingserializer',
        'Required parameter "settingserializer" was null or undefined when calling apiSettingsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/settings/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: SettingserializerToJSON(requestParameters['settingserializer']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SettingserializerFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows settings (risk thresholds) to be viewed or edited.
   */
  async apiSettingsCreate(
    requestParameters: ApiSettingsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Settingserializer> {
    const response = await this.apiSettingsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows settings (risk thresholds) to be viewed or edited.
   */
  async apiSettingsDestroyRaw(
    requestParameters: ApiSettingsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiSettingsDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/settings/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint that allows settings (risk thresholds) to be viewed or edited.
   */
  async apiSettingsDestroy(
    requestParameters: ApiSettingsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiSettingsDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * API endpoint that allows settings (risk thresholds) to be viewed or edited.
   */
  async apiSettingsListRaw(
    requestParameters: ApiSettingsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedSettingserializerList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/settings/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedSettingserializerListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows settings (risk thresholds) to be viewed or edited.
   */
  async apiSettingsList(
    requestParameters: ApiSettingsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedSettingserializerList> {
    const response = await this.apiSettingsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows settings (risk thresholds) to be viewed or edited.
   */
  async apiSettingsPartialUpdateRaw(
    requestParameters: ApiSettingsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Settingserializer>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiSettingsPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/settings/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedSettingserializerToJSON(requestParameters['patchedSettingserializer']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SettingserializerFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows settings (risk thresholds) to be viewed or edited.
   */
  async apiSettingsPartialUpdate(
    requestParameters: ApiSettingsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Settingserializer> {
    const response = await this.apiSettingsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows settings (risk thresholds) to be viewed or edited.
   */
  async apiSettingsRetrieveRaw(
    requestParameters: ApiSettingsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Settingserializer>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiSettingsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/settings/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SettingserializerFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows settings (risk thresholds) to be viewed or edited.
   */
  async apiSettingsRetrieve(
    requestParameters: ApiSettingsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Settingserializer> {
    const response = await this.apiSettingsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows settings (risk thresholds) to be viewed or edited.
   */
  async apiSettingsUpdateRaw(
    requestParameters: ApiSettingsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Settingserializer>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiSettingsUpdate().',
      );
    }

    if (requestParameters['settingserializer'] == null) {
      throw new runtime.RequiredError(
        'settingserializer',
        'Required parameter "settingserializer" was null or undefined when calling apiSettingsUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/settings/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: SettingserializerToJSON(requestParameters['settingserializer']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SettingserializerFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows settings (risk thresholds) to be viewed or edited.
   */
  async apiSettingsUpdate(
    requestParameters: ApiSettingsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Settingserializer> {
    const response = await this.apiSettingsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for the global library of user-defined style criteria used by the Style metric. Filter by `?task_type=` to get the criteria for one task type.
   */
  async apiStyleCriteriaCreateRaw(
    requestParameters: ApiStyleCriteriaCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<StyleCriterion>> {
    if (requestParameters['styleCriterion'] == null) {
      throw new runtime.RequiredError(
        'styleCriterion',
        'Required parameter "styleCriterion" was null or undefined when calling apiStyleCriteriaCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/style_criteria/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: StyleCriterionToJSON(requestParameters['styleCriterion']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => StyleCriterionFromJSON(jsonValue));
  }

  /**
   * API endpoint for the global library of user-defined style criteria used by the Style metric. Filter by `?task_type=` to get the criteria for one task type.
   */
  async apiStyleCriteriaCreate(
    requestParameters: ApiStyleCriteriaCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<StyleCriterion> {
    const response = await this.apiStyleCriteriaCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for the global library of user-defined style criteria used by the Style metric. Filter by `?task_type=` to get the criteria for one task type.
   */
  async apiStyleCriteriaDestroyRaw(
    requestParameters: ApiStyleCriteriaDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiStyleCriteriaDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/style_criteria/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint for the global library of user-defined style criteria used by the Style metric. Filter by `?task_type=` to get the criteria for one task type.
   */
  async apiStyleCriteriaDestroy(
    requestParameters: ApiStyleCriteriaDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiStyleCriteriaDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * API endpoint for the global library of user-defined style criteria used by the Style metric. Filter by `?task_type=` to get the criteria for one task type.
   */
  async apiStyleCriteriaListRaw(
    requestParameters: ApiStyleCriteriaListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedStyleCriterionList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['taskType'] != null) {
      queryParameters['task_type'] = requestParameters['taskType'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/style_criteria/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedStyleCriterionListFromJSON(jsonValue));
  }

  /**
   * API endpoint for the global library of user-defined style criteria used by the Style metric. Filter by `?task_type=` to get the criteria for one task type.
   */
  async apiStyleCriteriaList(
    requestParameters: ApiStyleCriteriaListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedStyleCriterionList> {
    const response = await this.apiStyleCriteriaListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for the global library of user-defined style criteria used by the Style metric. Filter by `?task_type=` to get the criteria for one task type.
   */
  async apiStyleCriteriaPartialUpdateRaw(
    requestParameters: ApiStyleCriteriaPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<StyleCriterion>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiStyleCriteriaPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/style_criteria/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedStyleCriterionToJSON(requestParameters['patchedStyleCriterion']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => StyleCriterionFromJSON(jsonValue));
  }

  /**
   * API endpoint for the global library of user-defined style criteria used by the Style metric. Filter by `?task_type=` to get the criteria for one task type.
   */
  async apiStyleCriteriaPartialUpdate(
    requestParameters: ApiStyleCriteriaPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<StyleCriterion> {
    const response = await this.apiStyleCriteriaPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for the global library of user-defined style criteria used by the Style metric. Filter by `?task_type=` to get the criteria for one task type.
   */
  async apiStyleCriteriaRetrieveRaw(
    requestParameters: ApiStyleCriteriaRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<StyleCriterion>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiStyleCriteriaRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/style_criteria/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => StyleCriterionFromJSON(jsonValue));
  }

  /**
   * API endpoint for the global library of user-defined style criteria used by the Style metric. Filter by `?task_type=` to get the criteria for one task type.
   */
  async apiStyleCriteriaRetrieve(
    requestParameters: ApiStyleCriteriaRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<StyleCriterion> {
    const response = await this.apiStyleCriteriaRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for the global library of user-defined style criteria used by the Style metric. Filter by `?task_type=` to get the criteria for one task type.
   */
  async apiStyleCriteriaUpdateRaw(
    requestParameters: ApiStyleCriteriaUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<StyleCriterion>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiStyleCriteriaUpdate().',
      );
    }

    if (requestParameters['styleCriterion'] == null) {
      throw new runtime.RequiredError(
        'styleCriterion',
        'Required parameter "styleCriterion" was null or undefined when calling apiStyleCriteriaUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/style_criteria/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: StyleCriterionToJSON(requestParameters['styleCriterion']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => StyleCriterionFromJSON(jsonValue));
  }

  /**
   * API endpoint for the global library of user-defined style criteria used by the Style metric. Filter by `?task_type=` to get the criteria for one task type.
   */
  async apiStyleCriteriaUpdate(
    requestParameters: ApiStyleCriteriaUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<StyleCriterion> {
    const response = await this.apiStyleCriteriaUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Download template file
   */
  async apiTemplateDownloadRetrieveRaw(
    requestParameters: ApiTemplateDownloadRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RequirementTemplate>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiTemplateDownloadRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/template-download/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RequirementTemplateFromJSON(jsonValue));
  }

  /**
   * Download template file
   */
  async apiTemplateDownloadRetrieve(
    requestParameters: ApiTemplateDownloadRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RequirementTemplate> {
    const response = await this.apiTemplateDownloadRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiTextFieldTemplatesListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<TextFieldTemplate>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/text-field-templates/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue.map(TextFieldTemplateFromJSON));
  }

  /**
   */
  async apiTextFieldTemplatesList(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<TextFieldTemplate>> {
    const response = await this.apiTextFieldTemplatesListRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async apiTreemapRetrieveRaw(
    requestParameters: ApiTreemapRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TreeMapResponse>> {
    if (requestParameters['questionnaireId'] == null) {
      throw new runtime.RequiredError(
        'questionnaireId',
        'Required parameter "questionnaireId" was null or undefined when calling apiTreemapRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/treemap/{questionnaire_id}`.replace(
          `{${'questionnaire_id'}}`,
          encodeURIComponent(String(requestParameters['questionnaireId'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => TreeMapResponseFromJSON(jsonValue));
  }

  /**
   */
  async apiTreemapRetrieve(
    requestParameters: ApiTreemapRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TreeMapResponse> {
    const response = await this.apiTreemapRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiUseCaseNamesListRaw(
    requestParameters: ApiUseCaseNamesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<UseCaseName>>> {
    const queryParameters: any = {};

    if (requestParameters['aimodels'] != null) {
      queryParameters['aimodels'] = requestParameters['aimodels'];
    }

    if (requestParameters['businessOwner'] != null) {
      queryParameters['business_owner'] = requestParameters['businessOwner'];
    }

    if (requestParameters['department'] != null) {
      queryParameters['department'] = requestParameters['department'];
    }

    if (requestParameters['description'] != null) {
      queryParameters['description'] = requestParameters['description'];
    }

    if (requestParameters['euAiActRiskClass'] != null) {
      queryParameters['eu_ai_act_risk_class'] = requestParameters['euAiActRiskClass'];
    }

    if (requestParameters['materiality'] != null) {
      queryParameters['materiality'] = requestParameters['materiality'];
    }

    if (requestParameters['name'] != null) {
      queryParameters['name'] = requestParameters['name'];
    }

    if (requestParameters['purpose'] != null) {
      queryParameters['purpose'] = requestParameters['purpose'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/use_case_names/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue.map(UseCaseNameFromJSON));
  }

  /**
   */
  async apiUseCaseNamesList(
    requestParameters: ApiUseCaseNamesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<UseCaseName>> {
    const response = await this.apiUseCaseNamesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Get the counts of models filter categories.  Each category is counted against a queryset that has every *other* active filter applied but not its own, so selecting an option never zeroes out the sibling options in the same category.
   */
  async apiUseCasesCountsRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<UseCaseCount>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/use_cases/counts/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => UseCaseCountFromJSON(jsonValue));
  }

  /**
   * Get the counts of models filter categories.  Each category is counted against a queryset that has every *other* active filter applied but not its own, so selecting an option never zeroes out the sibling options in the same category.
   */
  async apiUseCasesCountsRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UseCaseCount> {
    const response = await this.apiUseCasesCountsRetrieveRaw(initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows AI use cases to be viewed or edited.
   */
  async apiUseCasesCreateRaw(
    requestParameters: ApiUseCasesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<UseCaseWrite>> {
    if (requestParameters['useCaseWrite'] == null) {
      throw new runtime.RequiredError(
        'useCaseWrite',
        'Required parameter "useCaseWrite" was null or undefined when calling apiUseCasesCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/use_cases/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: UseCaseWriteToJSON(requestParameters['useCaseWrite']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => UseCaseWriteFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows AI use cases to be viewed or edited.
   */
  async apiUseCasesCreate(
    requestParameters: ApiUseCasesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<UseCaseWrite> {
    const response = await this.apiUseCasesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows AI use cases to be viewed or edited.
   */
  async apiUseCasesDestroyRaw(
    requestParameters: ApiUseCasesDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiUseCasesDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/use_cases/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint that allows AI use cases to be viewed or edited.
   */
  async apiUseCasesDestroy(
    requestParameters: ApiUseCasesDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiUseCasesDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * API endpoint that allows AI use cases to be viewed or edited.
   */
  async apiUseCasesListRaw(
    requestParameters: ApiUseCasesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedUseCaseListList>> {
    const queryParameters: any = {};

    if (requestParameters['aimodels'] != null) {
      queryParameters['aimodels'] = requestParameters['aimodels'];
    }

    if (requestParameters['businessOwner'] != null) {
      queryParameters['business_owner'] = requestParameters['businessOwner'];
    }

    if (requestParameters['department'] != null) {
      queryParameters['department'] = requestParameters['department'];
    }

    if (requestParameters['description'] != null) {
      queryParameters['description'] = requestParameters['description'];
    }

    if (requestParameters['euAiActRiskClass'] != null) {
      queryParameters['eu_ai_act_risk_class'] = requestParameters['euAiActRiskClass'];
    }

    if (requestParameters['materiality'] != null) {
      queryParameters['materiality'] = requestParameters['materiality'];
    }

    if (requestParameters['name'] != null) {
      queryParameters['name'] = requestParameters['name'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    if (requestParameters['purpose'] != null) {
      queryParameters['purpose'] = requestParameters['purpose'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/use_cases/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedUseCaseListListFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows AI use cases to be viewed or edited.
   */
  async apiUseCasesList(
    requestParameters: ApiUseCasesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedUseCaseListList> {
    const response = await this.apiUseCasesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows AI use cases to be viewed or edited.
   */
  async apiUseCasesPartialUpdateRaw(
    requestParameters: ApiUseCasesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<UseCaseWrite>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiUseCasesPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/use_cases/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedUseCaseWriteToJSON(requestParameters['patchedUseCaseWrite']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => UseCaseWriteFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows AI use cases to be viewed or edited.
   */
  async apiUseCasesPartialUpdate(
    requestParameters: ApiUseCasesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<UseCaseWrite> {
    const response = await this.apiUseCasesPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows AI use cases to be viewed or edited.
   */
  async apiUseCasesRetrieveRaw(
    requestParameters: ApiUseCasesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<UseCaseDetail>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiUseCasesRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/use_cases/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => UseCaseDetailFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows AI use cases to be viewed or edited.
   */
  async apiUseCasesRetrieve(
    requestParameters: ApiUseCasesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<UseCaseDetail> {
    const response = await this.apiUseCasesRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Generate a new share token, invalidating any existing active tokens.
   */
  async apiUseCasesShareTokenCreateRaw(
    requestParameters: ApiUseCasesShareTokenCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<UseCaseWrite>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiUseCasesShareTokenCreate().',
      );
    }

    if (requestParameters['useCaseWrite'] == null) {
      throw new runtime.RequiredError(
        'useCaseWrite',
        'Required parameter "useCaseWrite" was null or undefined when calling apiUseCasesShareTokenCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/use_cases/{id}/share-token/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: UseCaseWriteToJSON(requestParameters['useCaseWrite']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => UseCaseWriteFromJSON(jsonValue));
  }

  /**
   * Generate a new share token, invalidating any existing active tokens.
   */
  async apiUseCasesShareTokenCreate(
    requestParameters: ApiUseCasesShareTokenCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<UseCaseWrite> {
    const response = await this.apiUseCasesShareTokenCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows AI use cases to be viewed or edited.
   */
  async apiUseCasesUpdateRaw(
    requestParameters: ApiUseCasesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<UseCaseWrite>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiUseCasesUpdate().',
      );
    }

    if (requestParameters['useCaseWrite'] == null) {
      throw new runtime.RequiredError(
        'useCaseWrite',
        'Required parameter "useCaseWrite" was null or undefined when calling apiUseCasesUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/use_cases/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: UseCaseWriteToJSON(requestParameters['useCaseWrite']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => UseCaseWriteFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows AI use cases to be viewed or edited.
   */
  async apiUseCasesUpdate(
    requestParameters: ApiUseCasesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<UseCaseWrite> {
    const response = await this.apiUseCasesUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * View settings are stored in the database and used to store the user preferences for filters and columns of the tables.
   */
  async apiViewSettingsListRaw(
    requestParameters: ApiViewSettingsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedViewSettingsList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/view_settings/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedViewSettingsListFromJSON(jsonValue));
  }

  /**
   * View settings are stored in the database and used to store the user preferences for filters and columns of the tables.
   */
  async apiViewSettingsList(
    requestParameters: ApiViewSettingsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedViewSettingsList> {
    const response = await this.apiViewSettingsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * View settings are stored in the database and used to store the user preferences for filters and columns of the tables.
   */
  async apiViewSettingsPartialUpdateRaw(
    requestParameters: ApiViewSettingsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ViewSettings>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiViewSettingsPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/view_settings/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedViewSettingsToJSON(requestParameters['patchedViewSettings']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ViewSettingsFromJSON(jsonValue));
  }

  /**
   * View settings are stored in the database and used to store the user preferences for filters and columns of the tables.
   */
  async apiViewSettingsPartialUpdate(
    requestParameters: ApiViewSettingsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ViewSettings> {
    const response = await this.apiViewSettingsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * View settings are stored in the database and used to store the user preferences for filters and columns of the tables.
   */
  async apiViewSettingsRetrieveRaw(
    requestParameters: ApiViewSettingsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ViewSettings>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiViewSettingsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/view_settings/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ViewSettingsFromJSON(jsonValue));
  }

  /**
   * View settings are stored in the database and used to store the user preferences for filters and columns of the tables.
   */
  async apiViewSettingsRetrieve(
    requestParameters: ApiViewSettingsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ViewSettings> {
    const response = await this.apiViewSettingsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const ApiAiModelNamesListAssessmentStatusEnum = {
  failed: 'FAILED',
  notStarted: 'NOT_STARTED',
  pending: 'PENDING',
  retry: 'RETRY',
  running: 'RUNNING',
  success: 'SUCCESS',
  successWithErrors: 'SUCCESS_WITH_ERRORS',
} as const;
export type ApiAiModelNamesListAssessmentStatusEnum =
  (typeof ApiAiModelNamesListAssessmentStatusEnum)[keyof typeof ApiAiModelNamesListAssessmentStatusEnum];
/**
 * @export
 */
export const ApiAiModelNamesListDeploymentStatusEnum = {
  inReview: 'in review',
  live: 'live',
  notLive: 'not live',
} as const;
export type ApiAiModelNamesListDeploymentStatusEnum =
  (typeof ApiAiModelNamesListDeploymentStatusEnum)[keyof typeof ApiAiModelNamesListDeploymentStatusEnum];
/**
 * @export
 */
export const ApiAiModelNamesListTaskTypeEnum = {
  concierge: 'concierge',
  conversationalAgent: 'conversational_agent',
  informationExtraction: 'information_extraction',
  singleTurnChat: 'single_turn_chat',
  tabularMl: 'tabular_ml',
  textGeneration: 'text_generation',
  voiceAgent: 'voice_agent',
} as const;
export type ApiAiModelNamesListTaskTypeEnum =
  (typeof ApiAiModelNamesListTaskTypeEnum)[keyof typeof ApiAiModelNamesListTaskTypeEnum];
/**
 * @export
 */
export const ApiAiModelsListAssessmentStatusEnum = {
  failed: 'FAILED',
  notStarted: 'NOT_STARTED',
  pending: 'PENDING',
  retry: 'RETRY',
  running: 'RUNNING',
  success: 'SUCCESS',
  successWithErrors: 'SUCCESS_WITH_ERRORS',
} as const;
export type ApiAiModelsListAssessmentStatusEnum =
  (typeof ApiAiModelsListAssessmentStatusEnum)[keyof typeof ApiAiModelsListAssessmentStatusEnum];
/**
 * @export
 */
export const ApiAiModelsListDeploymentStatusEnum = {
  inReview: 'in review',
  live: 'live',
  notLive: 'not live',
} as const;
export type ApiAiModelsListDeploymentStatusEnum =
  (typeof ApiAiModelsListDeploymentStatusEnum)[keyof typeof ApiAiModelsListDeploymentStatusEnum];
/**
 * @export
 */
export const ApiAiModelsListTaskTypeEnum = {
  concierge: 'concierge',
  conversationalAgent: 'conversational_agent',
  informationExtraction: 'information_extraction',
  singleTurnChat: 'single_turn_chat',
  tabularMl: 'tabular_ml',
  textGeneration: 'text_generation',
  voiceAgent: 'voice_agent',
} as const;
export type ApiAiModelsListTaskTypeEnum =
  (typeof ApiAiModelsListTaskTypeEnum)[keyof typeof ApiAiModelsListTaskTypeEnum];
/**
 * @export
 */
export const ApiAssessmentsListAiModelTaskTypeEnum = {
  concierge: 'concierge',
  conversationalAgent: 'conversational_agent',
  informationExtraction: 'information_extraction',
  singleTurnChat: 'single_turn_chat',
  tabularMl: 'tabular_ml',
  textGeneration: 'text_generation',
  voiceAgent: 'voice_agent',
} as const;
export type ApiAssessmentsListAiModelTaskTypeEnum =
  (typeof ApiAssessmentsListAiModelTaskTypeEnum)[keyof typeof ApiAssessmentsListAiModelTaskTypeEnum];
/**
 * @export
 */
export const ApiAssessmentsListOrderingEnum = {
  descId: 'desc_id',
  id: 'id',
} as const;
export type ApiAssessmentsListOrderingEnum =
  (typeof ApiAssessmentsListOrderingEnum)[keyof typeof ApiAssessmentsListOrderingEnum];
/**
 * @export
 */
export const ApiAssessmentsListStatusEnum = {
  failed: 'FAILED',
  notStarted: 'NOT_STARTED',
  pending: 'PENDING',
  retry: 'RETRY',
  running: 'RUNNING',
  success: 'SUCCESS',
  successWithErrors: 'SUCCESS_WITH_ERRORS',
} as const;
export type ApiAssessmentsListStatusEnum =
  (typeof ApiAssessmentsListStatusEnum)[keyof typeof ApiAssessmentsListStatusEnum];
/**
 * @export
 */
export const ApiCommentsListWhichPageEnum = {
  governance: 'GOVERNANCE',
  riskprofile: 'RISKPROFILE',
} as const;
export type ApiCommentsListWhichPageEnum =
  (typeof ApiCommentsListWhichPageEnum)[keyof typeof ApiCommentsListWhichPageEnum];
/**
 * @export
 */
export const ApiCredentialsListTaskTypeEnum = {
  concierge: 'concierge',
  conversationalAgent: 'conversational_agent',
  informationExtraction: 'information_extraction',
  singleTurnChat: 'single_turn_chat',
  tabularMl: 'tabular_ml',
  textGeneration: 'text_generation',
  voiceAgent: 'voice_agent',
} as const;
export type ApiCredentialsListTaskTypeEnum =
  (typeof ApiCredentialsListTaskTypeEnum)[keyof typeof ApiCredentialsListTaskTypeEnum];
/**
 * @export
 */
export const ApiCredentialsListTypeEnum = {
  aino: 'AINO',
  azureOpenAiAssistant: 'AZURE_OPEN_AI_ASSISTANT',
  celina: 'CELINA',
  customApi: 'CUSTOM_API',
  livekit: 'LIVEKIT',
  openAiAssistant: 'OPEN_AI_ASSISTANT',
  poe: 'POE',
  spitch: 'SPITCH',
} as const;
export type ApiCredentialsListTypeEnum = (typeof ApiCredentialsListTypeEnum)[keyof typeof ApiCredentialsListTypeEnum];
/**
 * @export
 */
export const ApiCustomFieldDefinitionsListTargetModelEnum = {
  aiModel: 'ai_model',
  useCase: 'use_case',
} as const;
export type ApiCustomFieldDefinitionsListTargetModelEnum =
  (typeof ApiCustomFieldDefinitionsListTargetModelEnum)[keyof typeof ApiCustomFieldDefinitionsListTargetModelEnum];
/**
 * @export
 */
export const ApiRiskMetricsListTaskTypeEnum = {
  concierge: 'concierge',
  conversationalAgent: 'conversational_agent',
  informationExtraction: 'information_extraction',
  singleTurnChat: 'single_turn_chat',
  tabularMl: 'tabular_ml',
  textGeneration: 'text_generation',
  voiceAgent: 'voice_agent',
} as const;
export type ApiRiskMetricsListTaskTypeEnum =
  (typeof ApiRiskMetricsListTaskTypeEnum)[keyof typeof ApiRiskMetricsListTaskTypeEnum];
/**
 * @export
 */
export const ApiSchemaRetrieveFormatEnum = {
  json: 'json',
  yaml: 'yaml',
} as const;
export type ApiSchemaRetrieveFormatEnum =
  (typeof ApiSchemaRetrieveFormatEnum)[keyof typeof ApiSchemaRetrieveFormatEnum];
/**
 * @export
 */
export const ApiSchemaRetrieveLangEnum = {
  af: 'af',
  ar: 'ar',
  arDz: 'ar-dz',
  ast: 'ast',
  az: 'az',
  be: 'be',
  bg: 'bg',
  bn: 'bn',
  br: 'br',
  bs: 'bs',
  ca: 'ca',
  ckb: 'ckb',
  cs: 'cs',
  cy: 'cy',
  da: 'da',
  de: 'de',
  dsb: 'dsb',
  el: 'el',
  en: 'en',
  enAu: 'en-au',
  enGb: 'en-gb',
  eo: 'eo',
  es: 'es',
  esAr: 'es-ar',
  esCo: 'es-co',
  esMx: 'es-mx',
  esNi: 'es-ni',
  esVe: 'es-ve',
  et: 'et',
  eu: 'eu',
  fa: 'fa',
  fi: 'fi',
  fr: 'fr',
  fy: 'fy',
  ga: 'ga',
  gd: 'gd',
  gl: 'gl',
  he: 'he',
  hi: 'hi',
  hr: 'hr',
  hsb: 'hsb',
  hu: 'hu',
  hy: 'hy',
  ia: 'ia',
  id: 'id',
  ig: 'ig',
  io: 'io',
  is: 'is',
  it: 'it',
  ja: 'ja',
  ka: 'ka',
  kab: 'kab',
  kk: 'kk',
  km: 'km',
  kn: 'kn',
  ko: 'ko',
  ky: 'ky',
  lb: 'lb',
  lt: 'lt',
  lv: 'lv',
  mk: 'mk',
  ml: 'ml',
  mn: 'mn',
  mr: 'mr',
  ms: 'ms',
  my: 'my',
  nb: 'nb',
  ne: 'ne',
  nl: 'nl',
  nn: 'nn',
  os: 'os',
  pa: 'pa',
  pl: 'pl',
  pt: 'pt',
  ptBr: 'pt-br',
  ro: 'ro',
  ru: 'ru',
  sk: 'sk',
  sl: 'sl',
  sq: 'sq',
  sr: 'sr',
  srLatn: 'sr-latn',
  sv: 'sv',
  sw: 'sw',
  ta: 'ta',
  te: 'te',
  tg: 'tg',
  th: 'th',
  tk: 'tk',
  tr: 'tr',
  tt: 'tt',
  udm: 'udm',
  ug: 'ug',
  uk: 'uk',
  ur: 'ur',
  uz: 'uz',
  vi: 'vi',
  zhHans: 'zh-hans',
  zhHant: 'zh-hant',
} as const;
export type ApiSchemaRetrieveLangEnum = (typeof ApiSchemaRetrieveLangEnum)[keyof typeof ApiSchemaRetrieveLangEnum];
/**
 * @export
 */
export const ApiStyleCriteriaListTaskTypeEnum = {
  concierge: 'concierge',
  conversationalAgent: 'conversational_agent',
  informationExtraction: 'information_extraction',
  singleTurnChat: 'single_turn_chat',
  tabularMl: 'tabular_ml',
  textGeneration: 'text_generation',
  voiceAgent: 'voice_agent',
} as const;
export type ApiStyleCriteriaListTaskTypeEnum =
  (typeof ApiStyleCriteriaListTaskTypeEnum)[keyof typeof ApiStyleCriteriaListTaskTypeEnum];
/**
 * @export
 */
export const ApiUseCaseNamesListEuAiActRiskClassEnum = {
  highRisk: 'High Risk',
  limitedRisk: 'Limited Risk',
  minimalRisk: 'Minimal Risk',
  prohibitedVeryHighRisk: 'Prohibited / Very High Risk',
  toBeAssessed: 'To be assessed',
} as const;
export type ApiUseCaseNamesListEuAiActRiskClassEnum =
  (typeof ApiUseCaseNamesListEuAiActRiskClassEnum)[keyof typeof ApiUseCaseNamesListEuAiActRiskClassEnum];
/**
 * @export
 */
export const ApiUseCaseNamesListMaterialityEnum = {
  high: 'High',
  low: 'Low',
  medium: 'Medium',
} as const;
export type ApiUseCaseNamesListMaterialityEnum =
  (typeof ApiUseCaseNamesListMaterialityEnum)[keyof typeof ApiUseCaseNamesListMaterialityEnum];
/**
 * @export
 */
export const ApiUseCasesListEuAiActRiskClassEnum = {
  highRisk: 'High Risk',
  limitedRisk: 'Limited Risk',
  minimalRisk: 'Minimal Risk',
  prohibitedVeryHighRisk: 'Prohibited / Very High Risk',
  toBeAssessed: 'To be assessed',
} as const;
export type ApiUseCasesListEuAiActRiskClassEnum =
  (typeof ApiUseCasesListEuAiActRiskClassEnum)[keyof typeof ApiUseCasesListEuAiActRiskClassEnum];
/**
 * @export
 */
export const ApiUseCasesListMaterialityEnum = {
  high: 'High',
  low: 'Low',
  medium: 'Medium',
} as const;
export type ApiUseCasesListMaterialityEnum =
  (typeof ApiUseCasesListMaterialityEnum)[keyof typeof ApiUseCasesListMaterialityEnum];
